<template>
  <div v-bind:class="{ 'flexible-content': (ai !== 0 && ai !== 4 && !showFavs) }">
    <!--Navbar-->
    <navbar dark v-if="authorized && !loading && $route.path !== '/Quiz'"
      class="flexible-navbar blue-grey darken-4 animated slow fadeIn"
      :class="{ 'pl-0': (ai === 0 || ai === 4 || showFavs) }" position="top" name="b2.belca.by"
      href="https://b2.belca.by" scrolling>
      <navbar-collapse navbar-dark>
        <navbar-nav>
          <router-link to="/About" @click.native="chngai(0), catalogAnimated = 5">
            <a class="mobile-hide ml-3">
              <img
                :class="{ 'animated jello slow7 infinite': mover === false, 'animated slow rubberBand': mover === true }"
                @mouseover="mover = true" @mouseleave="mover = false" src="./assets/logo.png" alt="logo"
                style="width: 35px; height: 49px">
            </a>
          </router-link>
          <navbar-item v-if="false && authorized && (ai === 1 || ai === 0)" @click.native="showBonusModal = true"
            class="nav-link font-weight-bold waves-effect waves-lightwaves-fixed white-text hoverable"
            title="Акции и бонусы"><i class="fas fa-gift fa-lg yellow-text"></i>
            <span class="badge badge-pill cyan darken-1">{{ ProcentVipolneniya }}%</span>
          </navbar-item>
        </navbar-nav>

        <navbar-nav v-if="mng && ai !== 9 && ai !== 7 && contragents.length > 0">
        <navbar-item class="d-flex" style="width: 350px;">
          <select v-model.lazy="selectedContragent" class="form-control custom-select" id="inputGroupSelect01" @change="selectContragent($event)">
            <option v-for="(contragent, index) in contragents" :value="contragent" :key="index">{{ contragent.Kontragent }} </option>
          </select>
        </navbar-item>
      </navbar-nav>
         <router-link to="/Quiz"> </router-link>
        <div v-if="authorized && !loading" class="navbar-nav mr-0">
          <router-link to="/catalog" v-if="authorized">
            <navbar-item @click.native="chngai(1), showFavs = false, favkey = Math.random()"
              class="nav-link white-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable "
              v-bind:class="{ 'active': ai === 1, 'animated slow tada infinite': ai === 0 && catalogAnimated === 0 }"
              title="Создать резерв"><i class="fas fa-warehouse white-text fa-lg"></i><span
                class="badge badge-pill cyan darken-1 black-text"
                v-bind:class="{ 'animated slow infinite zoomIn': goods.length === 0 }">{{ goods.length
                }}</span>
            </navbar-item>
          </router-link>
          <navbar-item v-if="authorized && !hidebasket && ai !== 7 && ai !== 9"
            class="nav-link light-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable"
            v-bind:class="{ active: ai === 2 }" title=" Корзина "
            @click.native="getClientBasket(selectedContragent.UNP), showBasket = true"><i
              class="fas fa-cart-arrow-down white-text fa-lg"> </i><span class="badge badge-pill"
              :class="{ 'cyan darken-1': selectedContragentBasket.length === 0, 'green darken-1': selectedContragentBasket.length > 0 }">{{ selectedContragentBasket.length }}</span>
          </navbar-item>
          <navbar-item v-if="authorized && !hidebasket && ai !== 7 && ai !== 9"
            class="nav-link light-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable"
            v-bind:class="{ active: ai === 2 }" title=" Список заказов "
            @click.native="getOrderList(), showModalOrders = true"><i
              class="fas fa-file-invoice white-text fa-lg"></i><span
              class="badge badge-pill cyan darken-1">{{ orders.length }}</span>
          </navbar-item>
          <navbar-item
            v-if="Login === '100511773' || Login === '000000053' || Login === '000000054' || Login === '0000000055' && authorized && !hidebasket && ai !== 7 && ai !== 9"
            class="nav-link light-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable"
            v-bind:class="{ active: ai === 2 }" title=" Список заказов из базы Инфотроник "
            @click.native="getInfotronicOrderList(), showModalOrdersInfotronic = true"><i
              class="fas fa-truck-fast white-text fa-lg"></i><span
              class="badge badge-pill cyan darken-1">{{ ordersInfotronic.length }}</span>
          </navbar-item>
          <navbar-item v-if="authorized && mng && !hidebasket && ai !== 7 && ai !== 9"
            class="nav-link light-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable"
            v-bind:class="{ active: ai === 2 }" title=" Список заказных позиций "
            @click.native="getSpecialOrderList(), showModalSpecialOrders = true"><i
              class="fas fa-truck white-text fa-lg"></i><span
              class="badge badge-pill cyan darken-1">{{ specialOrders.length }}</span>
          </navbar-item>
          <navbar-item v-if="authorized && ai === 1" @click.native="showFavs = !showFavs, favkey = Math.random()"
            :key="favkey" class="nav-link font-weight-bold waves-effect waves-lightwaves-fixed white-text hoverable"
            v-bind:class="{ 'amber accent-4 animated fadeIn slow': showFavs === true }" title="Избранное"><i
              class="fas fa-heart fa-lg white-text"></i>
            <span class="badge badge-pill cyan darken-1">{{ this.goods.filter(good => good.fav === true).length }}</span>
          </navbar-item>
          <navbar-item v-if="authorized && ai !== 7 && ai !== 9" @click.native="showModal = true"
            title=" Взаиморасчеты "
            class="nav-link white-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable"
            v-bind:class="{ active: ai === 3 }"><b class="white-text"> {{ selectedContragent.priceCurrency }}</b> <span
              v-if="просроченныйДолг > 0" class="badge badge-pill badge-danger"
              title=" Просроченные оплаты. Кликните для детализации.  "> {{ просроченныйДолг }} </span>
            <span v-if="просроченныйДолг === 0 && selectedContragentBalance > 0" class="badge badge-pill cyan darken-1"
              title=" График оплаты. Кликните для детализации.  "> {{ selectedContragentBalance }} </span>
            <span v-if="просроченныйДолг === 0 && selectedContragentBalance <= 0" class="badge badge-pill badge-success"
              title=" График оплаты. Кликните для детализации.  "> {{ selectedContragentBalance }} </span>
          </navbar-item>
          <template v-if="false">
            <navbar-item class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable"
              v-bind:class="{ active: showPercent === true }" title=" Показать наценку "
              @click.native="showPercent = !showPercent"><i class="fas fa-percent"></i></navbar-item>
          </template>
          <router-link to="/information">
            <navbar-item v-if="ai !== 9 && !mng"
              class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable"
              v-bind:class="{ active: ai === 4 }" title=" Контактная информация " @click.native="chngai(4)"><i
                class="fas fa-address-book fa-lg white-text"></i>
            </navbar-item>
          </router-link>
          <navbar-item v-if="authorized && !mng" title="Скачать прайс-лист"
            class="nav-link light-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable"> <a
              :href="'https://b2.belca.by/1c/Prices/' + priceType + '.xlsx'" download><i
                class="fas fa-download fa-lg white-text"></i></a>
          </navbar-item>
        </div>
        <navbar-nav right>
          <router-link to="/statement">
            <navbar-item v-if="false && !mngsq"
              class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable"
              v-bind:class="{ active: ai === 10 }" title=" Выписка" @click.native="chngai(10)"
              @DateSelected="DateSelected($event)" :startDate="startDate" :endDate="endDate" :ai="ai"><i
                class="fas fa-euro-sign dark-grey-text fa-lg"></i></navbar-item>
          </router-link>
          <router-link to="/transit">
            <navbar-item @click.native="chngai(11)" v-if="false" :supplierTransit="supplierTransit"
              :supplierInvoice="supplierInvoice"
              class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable"
              v-bind:class="{ active: ai === 11 }" title=" Заказы поставщику "><i
                class="fas fa-shopping-basket dark-grey-text fa-lg"></i></navbar-item>
          </router-link>
          <router-link to="/order">
            <navbar-item @click.native="chngai(9)" :goods='goods' :orders='orders' :orderedOnly='orderedOnly'
              :selectedSchema='selectedSchema' :supplierOrder='supplierOrder' :orderFilter='orderFilter'
              :folder0='folder0' :folder1='folder1' :folder2='folder2' v-if="false && !mngsq"
              class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable"
              v-bind:class="{ active: ai === 9 }" title=" Рассчитать заказ товара "><i
                class="fas fa-truck dark-grey-text fa-lg"></i></navbar-item>
          </router-link>
          <router-link to="/sales">
            <navbar-item v-if="mng && ai !== 9" @b2bOrdersUniq="b2bOrdersUniq($event)"
              class="nav-link waves-effect waves-lightwaves-fixed hoverable" v-bind:class="{ active: ai === 7 }"
              title="Служебный раздел" @click.native="chngai(7)"><i class="fa-solid fa-people-roof fa-lg"
                :class="{ 'deep-orange-text': boss, 'orange-text': !boss }"></i>
            </navbar-item>
          </router-link>
          <login @logoff="logoff()" @showLogin="showLogin" :UID="UID" :mng="mng" :boss="boss" :authorized="authorized"
            @auth="firstLogin($event)">
          </login>
        </navbar-nav>
      </navbar-collapse>
    </navbar>
    <div v-if="authorized && $route.path !== '/Quiz'" :style="[ai === 0 ? { 'height': '40vh' } : { 'height': '30vh' }]"
      class="index-ornament">
      <div class="view intro-1" :style="[ai === 0 ? { 'height': '40vh' } : { 'height': '30vh' }]">
        <div class="full-bg-img">
          <div class="mask cyan darken-1">
            <div class="container flex-center mt-4 mb-2">
              <div v-if="ai === 7 && salesSubMode === 'Visits'" class="white-text text-center">
                Всего заказов
                <span class="badge orange darken-1" title=" Всего заказов"> {{ b2bOrdersTotal }}</span>
                В разные дни
                <span class="badge orange darken-1" title=" Уникальных заказов"> {{ b2bOrders }}</span>
              </div>
              <div v-if="ai === 7 && salesSubMode === 'SpecialOrdersRefresh'" class="white-text text-center">
                <b class="ml-auto mr-1 mt-1 align-self-center">Тип</b>
                <template>
                  <select v-model="specialOrdersType" class="custom-select custom-select-sm col-sm-2 mt-1" >
                    <option v-for="(type, index) in specialOrdersTypeList " :key="index" :value="index">{{ type }}</option>
                  </select>
                </template>
                <b class="ml-auto mr-1 mt-1 align-self-center">Статус</b>
                <template>
                  <select v-model="specialOrdersStatus" class="custom-select custom-select-sm col-sm-2 mt-1">
                    <option v-for="(status, index) in specialOrdersStatusList " :key="index" :value="index">{{ status }}
                    </option>
                  </select>
                </template>
                <b class="ml-auto mr-1 mt-1 align-self-center">Поставщик</b>
                <template>
                  <select v-model="specialOrdersSupplier" class="custom-select custom-select-sm col-sm-2 mt-1">
                    <option v-for="(supplier, index) in suppliers" :key="index" :value="index">{{ supplier }}</option>
                  </select>
                </template>
                <template>
                  <template>
                    <!-- Default unchecked -->
                    <div class="custom-control custom-checkbox custom-control-inline">
                      <input v-model="prihod" type="checkbox" class="custom-control-input" id="defaultUnchecked">
                      <label class="custom-control-label" for="defaultUnchecked">Оприходование</label>
                    </div>
                  </template>
                </template>
              </div>
              <div v-if="ai !== 7" class="white-text text-center">
                <h2 v-if="ai === 0 && !loading" class="mt-3 z-depth-0">
                  <b class="text-uppercase">Белый картридж</b>
                </h2>
                <h4 v-if="ai === 0" class="btn-call blue-grey darken-4 cyan-text z-depth-1">
                  <b>Помогаем печатать бизнес!</b>
                </h4>
                <p class="white-text" v-if="selectedContragentManager !== ''">Ваш персональный менеджер:<b
                    class="white-text"> {{ selectedContragentManager.FiszLico }}</b></p>
                <h2 class="mt-2" v-if="authorized">
                  <btn class="btn-call z-depth-2" size="sm" outline="info" title="Позвонить"><a
                      class="white-text telnumb text-weight-bold" href="tel:+375173880765">
                      <i class="fas fa-phone fa-lg"></i>+375 (17) 388 07 65</a>
                  </btn>
                  <btn v-if="selectedContragentManager !== '' && selectedContragentManager.ManagerTel !== ''"
                    class="btn-call z-depth-2" size="sm" outline="info" title="Позвонить"><a class="white-text telnumb"
                      :href="'tel:' + selectedContragentManager.ManagerTel">
                      <i class="fas fa-phone fa-lg"></i>{{ formatPhoneNumber(selectedContragentManager.ManagerTel) }}</a>
                  </btn>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/.Navbar-->
    <template>
      <!-- Sidebar -->
      <sidebar v-if="(ai != 0 && ai != 4)" @changeSalesSubMode="changeSalesSubMode($event)"
        @changedebt="partnersDebt = !partnersDebt" :salesSubMode="salesSubMode"
        @CreateSupplierOrder="CreateSupplierOrder()" @selectScheme="selectScheme($event)" :managers="managers"
        :Login="Login" :deliverySchemes='deliverySchemes' @changeordered="orderedOnly = !orderedOnly"
        @changeAll="orderFilter = 'All'" @changeInStock="orderFilter = 'inStock'"
        @changeNotInStock="orderFilter = 'NotInStock'" :partnersDebt='partnersDebt'
        @SupplierInvoice="getSupplierInvoice($event)" @DateSelected="DateSelected($event)" @load="load()"
        @selectManager="selectManager($event)" :contragents="contragents" :prices="prices" :activeMng="activeMng"
        :showFavs="showFavs" @folder0="getFolder0($event)" @folder1="getFolder1($event)" @folder2="getFolder2($event)"
        :loading="loading" :selectedManager='selectedManager' :supplierInvoice='supplierInvoice' :goods="goods"
        :folders="folders" :mng="mng" :boss="boss" :authorized="authorized" :ai="ai" :startDate="startDate"
        :endDate="endDate"></sidebar>
      <!-- /Sidebar  -->
      <main>
        <div>
          <modal v-if="mng && chatReady" removeBackdrop position="top-right">
            <chat></chat>
          </modal>
          <template v-if="showBasket === true">
            <basket :prices="prices" :mng="mng" :максДнейПросрочки="максДнейПросрочки"
              :selectedContragentManager="selectedContragentManager" :просроченныйДолг='просроченныйДолг' :долг='долг'
              :showBasket='showBasket' :goods='goods' :orders='orders' :activeOrder='activeOrder'
              :selectedContragent="selectedContragent" :selectedContragentBasket="selectedContragentBasket" :user='user'
              :comment='comment' :goodsInfotronic='goodsInfotronic' @emptyBasket="emptyBasket()"
              @closeBasket='showBasket = false' @addGood="addGood($event)"></basket>
          </template>
          <template v-if="showCRM === true">
            <CRM :selectedContragentDescription="selectedContragentDescription" :boss="boss"
              :partnerSalesByGroupsExport="partnerSalesByGroupsExport" @hideCRM="showCRM = false" :showCRM='showCRM'
              :goods='goods' :authorized='authorized' :user='user' :orders='orders' :mng='mng' :накладные='накладные'
              :partnerABCXYZ='partnerABCXYZ' :partnerSalesTotal='partnerSalesTotal' :partnerSales='partnerSales'
              :partnerSalesByGoodsExport='partnerSalesByGoodsExport'></CRM>
          </template>
          <router-view :activeMng="activeMng" :prihod="prihod" :specialOrdersSkladList="specialOrdersSkladList"
            :specialOrdersTypeList="specialOrdersTypeList" :specialOrdersType="specialOrdersType"
            :specialOrdersStatus="specialOrdersStatus" :specialOrdersStatusList="specialOrdersStatusList"
            :specialOrdersSupplier="specialOrdersSupplier" :suppliers="suppliers" :balance="balance" :bonus="bonus"
            :salesSubMode="salesSubMode" @b2bOrdersUniq="b2bOrdersUniq($event)" :loading="loading" :spinner="spinner"
            @load="load()" @loaded="loaded()" @spinneroff="spinneroff()"
            :selectedContragentManager="selectedContragentManager" :showFavs='showFavs' :showPercent='showPercent'
            :orderFilter="orderFilter" @orderCreated="orderCreated()" :supplierOrder="supplierOrder"
            :selectedSchema="selectedSchema" :deliverySchemes="deliverySchemes" :orderedOnly="orderedOnly"
            :salesReady="salesReady" :startDate="startDate" :endDate="endDate" :rateUSD="rateUSD"
            :partnersSalesByPeriod="partnersSalesByPeriod" @infoContragent="infoContragent($event)"
            :selectedManager="selectedManager" :contragents="contragents" :supplierTransit="supplierTransit"
            :supplierInvoice="supplierInvoice" :partnerSalesByGoodsExport="partnerSalesByGoodsExport" :folder0="folder0"
            :folder1="folder1" :folder2="folder2" :partnerSales="partnerSales" :managers="managers"
            :managerSalesTotal='managerSalesTotal' :managerSales='managerSales' :partnersABCXYZ="partnersABCXYZ"
            :partnerABCXYZ="partnerABCXYZ" :user="user" :stock="stock" :ai="ai" :authorized="authorized" :mng="mng"
            :comment="comment" :boss="boss" @changeFav="changeFav($event)" @chngai="chngai($event)"
            :selectedContragentBasket="selectedContragentBasket" :activeOrder="activeOrder"
            :selectedContragent="selectedContragent" :prices="prices" :goods="goods" :накладные="накладные"
            :goodsInfotronic="goodsInfotronic" :orders="orders" @orderUpdated="getOrderList()"
            @emptyBasket="emptytBasket()" @SupplierInvoice="getSupplierInvoice($event)"
            @DateSelected="DateSelected($event)" @addGood="addGood($event)" @auth="authorization($event)"
            :partnersDebt='partnersDebt'></router-view>
        </div>

        <footer v-if="authorized && ai === 0 && $route.path !== '/Quiz'" color="white"
          class="page-footer index-footer-ornament animated fadeIn"></footer>
        <footer v-if="authorized && ai === 1 && $route.path !== '/Quiz'" color="white"
          class="page-footer index-footer-ornament-start animated fadeIn"></footer>
        <footer v-if="!authorized && $route.path !== '/Quiz'" color="white"
          class="page-footer index-footer-ornament-start animated fadeIn"></footer>
        <modal v-if="showModalOrders" frame position="top" size="fluid" @close="showModalOrders = false">
          <modal-header color="blue-grey darken-4">
            <modal-title>Список активных заказов</modal-title>
          </modal-header>
          <modal-body>
            <!-- basket -->
            <tbl responsive striped sorting>
              <tbl-head color="blue-grey" textWhite>
                <tr>
                  <th scope="col">№</th>
                  <th scope="col">№ Заказа</th>
                  <th scope="col">Дата</th>
                  <th scope="col">Статус</th>
                  <th scope="col">Просмотреть</th>
                </tr>
              </tbl-head>
              <tbl-body>
                <tr v-for="(order, index) in orders" :key="index">
                  <th>{{ index + 1 }}</th>
                  <th>{{ order.Zakaz }}</th>
                  <th>{{ formatDate(order.Дата) }}</th>
                  <th>{{ order.Status }}</th>
                  <th @click="showOrder(order.Zakaz)"><span
                      class="input-group-text d-flex justify-content-center hoverable info-color-dark waves-effect waves-lightwaves-fixed"
                      style="cursor: pointer;" title='Показать заказ'><i
                        class="fa-regular fa-folder-open white-text"></i></span></th>
                </tr>
              </tbl-body>
            </tbl>
          </modal-body>
          <modal-footer class="d-flex justify-content-center">
            <div>
              <btn class="blue-grey darken-4" @click.native="showModalOrders = false">Назад</btn>
            </div>
          </modal-footer>
        </modal>
        <modal v-if="showModalSpecialOrders" frame position="top" size="fluid" @close="showModalSpecialOrders = false">
          <modal-header color="blue-grey darken-4" class="d-flex align-items-start flex-row mb-0">

            <button v-waves.circle.float @click="addSpecialOrder()"
              class="btn btn-sm text-white blue-grey hoverable animated fadeIn waves-effect waves-light  align-self-center"
              title="Добавить запрос"><i class="fa-regular fa-square-plus fa-2x"></i></button>
            <button v-waves.circle.float @click="getSpecialOrderList()"
              class="btn btn-sm text-white blue-grey  hoverable animated fadeIn waves-effect waves-light  align-self-center"
              title="Обновить"><i class="fa fa-refresh fa-2x" aria-hidden="true"></i></button>
            <div class="input-group pl-0 mb-1 mt-1">
              <input v-bind:value="searchGlobal" @input="debounceSearchGlobal" ref="inp"
                class="form-control flex-grow mt-1" type="text" placeholder="Поиск по всем запросам" aria-label="Search"
                title="Введите ключевые слова в поле поиска">
              <span class="btn btn-nav text-white blue-grey darken-1 hoverable align-self-center" title="Искать"
                @click="globalSearch()" id="basic-text1"><i class="fa fa-search text-grey"
                  aria-hidden="true"></i></span>
              <span class="btn btn-nav text-white blue-grey darken-1 hoverable align-self-center"
                title="Очистить поле ввода" @click="debounceCleanGlobal()" id="basic-text1"><i
                  class="fa fa-times text-grey" aria-hidden="true"></i></span>
              <template>
                <span class="btn btn-nav default-color" style="font-size: 12px;">
                  <input title="Импорт из файла XLSX" type="file" @change="onChange" />
                  <xlsx-read :file="file">
                    <xlsx-json @parsed="handleParsed">
                      <template #collection="{ collection }">
                        <div v-if="collection">
                          <ul>
                            <li v-for="item in collection" :key="item.id">
                              {{ item }}
                            </li>
                          </ul>
                        </div>
                      </template>
                    </xlsx-json>
                  </xlsx-read>
                </span>
              </template>
            </div>
            <download-excel class="btn btn-nav default-color align-self-center" title="Экспорт в файл XLSX"
              :fetch="fetchDataSpecial" :before-finish="finishDownloadSpecial" :fields="json_fields_Special"
              :stringifyLongNum="true" worksheet="specialOrders" name="specialOrders.xls">
              Экспорт <i class="fa-solid fa-file-excel"></i>
            </download-excel>

          </modal-header>

          <modal-title class="d-flex justify-content-start flex-row mt-0 mb-1 blue-grey white-text darken-4">
            <b v-if="false" class="ml-1 align-self-center" style="font-size: 12px;">Менеджер</b>
            <select v-if="false" title="Менеджер" v-model="selectedManager.ManagerCode"
              @change="selectManager(selectedManager.ManagerCode)" class="custom-select-sm w-10 mt-1  align-self-center"
              id="inputGroupSelect01">
              <template v-for="(manager, index) in managers">
                <option :key="index"> {{ manager.ManagerCode }}</option>
              </template>
            </select>
            <b class="ml-1 w-10 align-self-center" style="font-size: 12px;">Тип</b>
            <template>
              <select v-model="specialOrdersType" class="custom-select-sm w-10 mt-1  align-self-center" title="Тип"
                style="font-size: 12px;">
                <option v-for="(type, index) in specialOrdersTypeList " :key="index" :value="index">{{ type }}</option>
              </select>
            </template>
            <b class="ml-1 w-10 align-self-center" style="font-size: 12px;">Статус</b>
            <template>
              <select v-model="specialOrdersStatus" class="custom-select-sm w-10 mt-1  align-self-center" title="Статус"
                style="font-size: 12px;">
                <option v-for="(status, index) in specialOrdersStatusList " :key="index" :value="index">{{ status }}
                </option>
              </select>
            </template>
            <b class="ml-1 align-self-center" style="font-size: 12px;">Поставщик</b>
            <template>
              <select v-model="specialOrdersSupplier" style="font-size: 12px; width: 100px;" title="Поставщик"
                class="custom-select-sm mt-1  align-self-center">
                <option v-for="(supplier, index) in suppliers" :key="index" :value="index">{{ supplier }}</option>
              </select>
            </template>
            <div class="input-group md-form form-sm form-1 pl-0 mb-1 mt-1">
              <input v-bind:value="search" @input="debounceSearch" ref="inp" class="form-control mt-1 white-text"
                type="text" placeholder="Фильтр по своим запросам" aria-label="Search"
                title="Введите ключевые слова в поле фильтра">
              <button class="btn btn-sm text-white blue-grey input-group-append darken-1 hoverable align-self-center"
                title="Очистить поле ввода" @click="debounceClean()" id="basic-text1"><i class="fa fa-times text-grey"
                  aria-hidden="true"></i></button>
            </div>
            <span class="ml-1 align-self-center justify-items-end flex-column" title="Даты">
              <input class="custom-select-sm mt-1 ml-auto w-40 align-self-center" style="font-size: 12px;" type="text"
                id="datepicker-trigger" placeholder="Выберите даты" :value="formatDates(dateOne, dateTwo)">
              <modal class="black-text" removeBackdrop side position="top-right" size="sm"
                @close="showModalDate = false">
                <AirbnbStyleDatepicker :trigger-element-id="'datepicker-trigger'" :mode="'range'"
                  :fullscreen-mobile="true" :inline="false" :date-one="dateOne" :date-two="dateTwo"
                  @date-one-selected="val => { dateOne = val }" @date-two-selected="val => { dateTwo = val }"
                  @apply="apply()" />
              </modal>
            </span>
          </modal-title>

          <modal-body>
            <div v-for="(order, index) in groupedRecords " :key="index"
              class="card col-md-12 mb-2 cascading-admin-card">
              <div>
                <div class="d-flex flex-wrap justify-content-start align-self-center input-group-text small"
                  @click="selectSpecialOrder(order.data[0].guid)">
                  <p class="ml-auto col-sm-auto align-self-center input-group-text"><small> {{ order.date }} №
                      {{ order.number }}</small></p>
                  <p class="ml-auto col-sm-auto align-self-center input-group-text" title="Менеджер">
                    <small>{{ order.manager }}
                    </small></p>
                  <select v-bind:value="parseInt(order.sklad)" v-on:input="updateSklad($event.target.value, order)"
                    style="font-size: 12px;" class="ml-auto col-sm-1 input-group small" title="Склад">
                    <option v-for="(sklad, index) in specialOrdersSkladList " :key="index" :value="index">
                      <small>{{ sklad }}</small>
                    </option>
                  </select>

                  <select v-if="false" v-model.lazy="order.ClientUNP"
                    @change="updateClientUNP($event.target.value, order)" class="input-group mr-auto col-sm-1 small"
                    id="inputGroupSelect02" aria-label="Клиент" title="Клиент">
                    <template class="dropdown">
                      <option class="dropdown-item" v-for="(contragent, index) in contragents" :value="contragent.UNP"
                        :key="index">{{ contragent.Kontragent }}</option>
                    </template>
                  </select>

                  <input style="font-size: 12px;" class="mr-auto col-sm-1 input-group small"
                    type='text' v-bind:value="order.client" :disabled="order.status > 4? true : false"
                    v-on:change="updateClient($event.target.value, order)" aria-label="Клиент(уст)"
                    title="Клиент" />
                  <input style="font-size: 12px;" class="mr-auto col-sm input-group small"
                   :readonly="parseInt(order.status) > 4" type='text' v-bind:value="order.good"
                    v-on:change="updateGood($event.target.value, order)" aria-label="Товар" title="Товар" />
                  <input style="font-size: 12px;" class="mr-auto col-sm-1 input-group small"
                  :readonly="order.status > 4" type='text' v-bind:value="order.quantity"
                    v-on:change="updateQty($event.target.value, order)" aria-label="Количество" title="Количество" />

                </div>

                <div v-for="(resp, index) in order.data " :key="index" @click="selectSpecialOrder(resp.guid)"
                  class="d-flex flex-wrap justify-content-start align-self-center input-group-text-sm">
                  <input style="font-size: 12px;" class="mr-auto col-sm-2 input-group-text-sm" readonly type='text'
                    v-model="resp.price" aria-label="Цена" title="Цена" />
                  <input style="font-size: 12px;" class="mr-auto col-sm-1 input-group-text-sm" readonly type='text'
                    v-model="resp.term" aria-label="Срок" title="Срок поставки" />
                  <input style="font-size: 12px;" class="mr-auto col-sm input-group-text-sm" readonly type="textarea"
                    v-model="resp.response" aria-label="Комментарий" title="Комментарий" />
                  <template>
                    <select v-bind:value="resp.type" v-on:input="updateType($event.target.value, resp.guid)"
                      style="font-size: 12px;" class="ml-auto col-sm-1 input-group" title="Тип заказа">
                      <option v-for="(type, index) in specialOrdersTypeList " :key="index" :value="index">{{ type }}
                      </option>
                    </select>
                    <select v-bind:value="resp.supplier" v-on:input="updateSupplier($event.target.value, resp.guid)"
                      style="font-size: 12px;" class="col-sm-1 input-group" title="Поставщик">
                      <option v-for="(supplier, index) in suppliers" :key="index" :value="index">
                        <small>{{ supplier }}</small></option>
                    </select>
                  </template>

                  <template>
                    <select v-bind:value="parseInt(resp.status)" style="font-size: 12px;"
                      class="ml-auto col-sm-1 input-group small"
                      :class="{ ' lime lighten-5': resp.status === 2, 'rgba-green-slight': resp.status === 3, 'light-blue lighten-5': resp.status === 4, 'teal lighten-5': resp.status === 5, 'amber darken-4': resp.status === 6, 'success-color': resp.status === 7 }"
                      title="Статус" @input="changeStatus($event.target.value, resp.guid)">
                      <option v-for="(status, index) in specialOrdersStatusList " :key="index" :value="index">
                        <small>{{ status }}</small></option>
                    </select>
                    <b v-if="parseInt(resp.status) === 7" style="font-size: 12px;"
                      class="mr-auto align-self-center input-group-text small"><small>Заказ</small></b>
                    <input v-if="parseInt(resp.status) === 7" style="font-size: 12px;"
                      class="ml-auto col-sm red-text readonly input-group-text small" type='text'
                      v-model="resp.ordernumber" aria-label="Заказ в базе" title="Заказ в базе" />
                    <button v-if="parseInt(resp.status) === 8 && selectedSpecialOrder === resp.guid"
                      @click="deleteSpecialOrder(resp.guid)" type="btn btn-sm"
                      class="input-group-text text-white hoverable danger-color small" title="Удалить"><i
                        class="fas fa-trash"></i></button>
                    <button v-if="parseInt(resp.status) !== 8 && selectedSpecialOrder === resp.guid"
                      @click="writeSpecialOrderFile()" type="btn btn-sm"
                      class="input-group-text text-white hoverable info-color small" title="Сохранить"><i
                        class="fa fa-check"></i></button>
                  </template>

                </div>
              </div>
            </div>
          </modal-body>
          <modal-footer class="d-flex justify-content-center">
            <div>
              <btn class="blue-grey darken-4" @click.native="showModalSpecialOrders = false">Назад</btn>
            </div>
          </modal-footer>
        </modal>
        <modal v-if="showModalOrdersInfotronic" frame position="top" size="fluid"
          @close="showModalOrdersInfotronic = false">
          <modal-header color="blue-grey darken-4">
            <modal-title>Список заказов Инфотроник</modal-title>
          </modal-header>
          <modal-body>
            <!-- basket -->
            <tbl responsive striped sorting>
              <tbl-head color="blue-grey" textWhite>
                <tr>
                  <th scope="col">№</th>
                  <th scope="col">№ Заказа</th>
                  <th scope="col">Дата</th>
                  <th scope="col">Просмотреть</th>

                </tr>
              </tbl-head>
              <tbl-body>
                <tr v-for="(order, index) in ordersInfotronic" :key="index">
                  <th>{{ index + 1 }}</th>
                  <th>{{ order.Number }}</th>
                  <th>{{ formatDate(order.Date) }}</th>

                  <th @click="showOrderInfotronic(order.Number)"><span
                      class="input-group-text d-flex justify-content-center hoverable info-color-dark waves-effect waves-lightwaves-fixed"
                      style="cursor: pointer;" title='Показать заказ'><i
                        class="fa-regular fa-folder-open white-text"></i></span></th>
                </tr>
              </tbl-body>
            </tbl>
          </modal-body>
          <modal-footer class="d-flex justify-content-center">
            <div>
              <btn class="blue-grey darken-4" @click.native="showModalOrdersInfotronic = false">Назад</btn>
            </div>
          </modal-footer>
        </modal>
        <modal v-if="showModalGlobalSearch" frame position="top" size="fluid" @close="showModalGlobalSearch = false">
          <modal-header color="blue-grey darken-4">
            <modal-title>Список похожих заказов</modal-title>
          </modal-header>
          <modal-body>
            <div v-for="(order, index) in groupedRecordsGlobal " :key="index"
              class="card col-md-12 mb-2 cascading-admin-card">
              <div>
                <div class="d-flex flex-wrap justify-content-start align-self-center input-group-text small"
                  @click="selectSpecialOrder(order.data[0].guid)">
                  <p class="ml-auto col-sm-auto align-self-center input-group-text"><small> {{ order.date }} №
                      {{ order.number }}</small></p>
                  <p class="ml-auto col-sm-auto align-self-center input-group-text" title="Менеджер">
                    <small>{{ order.manager }}
                    </small></p>
                  <input style="font-size: 12px;" class="mr-auto col-sm-2 input-group-text small" readonly type='text'
                    v-bind:value="order.client" aria-label="Клиент" title="Клиент" />
                  <input style="font-size: 12px;" class="mr-auto col-sm input-group-text small" readonly type='text'
                    v-bind:value="order.good" aria-label="Товар" title="Товар" />
                  <input style="font-size: 12px;" class="mr-auto col-sm-1 input-group-text small" readonly type='text'
                    v-bind:value="order.quantity" aria-label="Количество" title="Количество" />

                </div>

                <div v-for="(resp, index) in order.data " :key="index" @click="selectSpecialOrder(resp.guid)"
                  class="d-flex flex-wrap justify-content-start align-self-center input-group-text-sm">
                  <input style="font-size: 12px;" class="mr-auto col-sm-2 input-group-text-sm" readonly type='text'
                    v-model="resp.price" aria-label="Цена" title="Цена" />
                  <input style="font-size: 12px;" class="mr-auto col-sm-1 input-group-text-sm" readonly type='text'
                    v-model="resp.term" aria-label="Срок" title="Срок поставки" />
                  <input style="font-size: 12px;" class="mr-auto col-sm input-group-text-sm" readonly type="textarea"
                    v-model="resp.response" aria-label="Комментарий" title="Комментарий" />
                  <template>
                    <select v-bind:value="order.type" readonly style="font-size: 12px;"
                      class="ml-auto col-sm-1 input-group" disabled title="Тип заказа">
                      <option v-for="(type, index) in specialOrdersTypeList " :key="index" :value="index">{{ type }}
                      </option>
                    </select>
                    <select v-model="resp.supplier" style="font-size: 12px;"
                      class="col-sm-1 readonly disabled input-group-text-sm" title="Поставщик">
                      <option v-for="(supplier, index) in suppliers" :key="index" :value="index">
                        <small>{{ supplier }}</small></option>
                    </select>
                  </template>

                  <template>
                    <select v-bind:value="parseInt(resp.status)" style="font-size: 12px;" disabled
                      class="ml-auto col-sm-1 input-group small"
                      :class="{ ' lime lighten-5': resp.status === 2, 'rgba-green-slight': resp.status === 3, 'light-blue lighten-5': resp.status === 4, 'teal lighten-5': resp.status === 5, 'amber darken-4': resp.status === 6, 'success-color': resp.status === 7 }"
                      title="Статус">
                      <option v-for="(status, index) in specialOrdersStatusList " :key="index" :value="index">
                        <small>{{ status }}</small></option>
                    </select>

                  </template>

                </div>
              </div>
            </div>
          </modal-body>
        </modal>
        <modal v-if="showOrderModal" frame position="top" size="lg" @close="showOrderModal = false">
          <modal-header color="blue-grey darken-4">
            <modal-title>Заказ № {{ selectedOrderNumber }}</modal-title>
          </modal-header>
          <modal-body>
            <!-- basket -->
            <tbl responsive striped>
              <tbl-head color="blue-grey" textWhite>
                <tr>
                  <th scope="col">№</th>
                  <th scope="col">Код</th>
                  <th scope="col">Наименование</th>
                  <th scope="col">Количество</th>
                  <th scope="col">Цена с НДС</th>
                  <th scope="col">Сумма с НДС</th>
                </tr>
              </tbl-head>
              <tbl-body>
                <tr v-for="(item, index) in selectedOrder.products" :key="index">
                  <th>{{ index + 1 }}</th>
                  <th>{{ item.Code }}</th>
                  <th>{{ item.naim }}</th>
                  <th>{{ item.quantity }}</th>
                  <th>{{ item.PriceWithNDS }}</th>
                  <th>{{ item.SummaWithNDS }}</th>

                </tr>
                <tr>
                  <th>ИТОГО:</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th>{{ selectedOrder.SummaDokumenta }} {{ selectedOrder.Valuta }}</th>
                </tr>
                <tr>
                  <td colspan="6">КОММЕНТАРИЙ: {{ selectedOrder.Comment }}</td>
                </tr>
              </tbl-body>
            </tbl>
          </modal-body>
          <modal-footer class="d-flex justify-content-center">
            <div>
              <btn class="blue-grey darken-4" @click.native="showOrderModal = false">Назад</btn>
            </div>
          </modal-footer>
        </modal>
        <modal v-if="showOrderModalInfotronic" frame position="top" size="lg" @close="showOrderModalInfotronic = false">
          <modal-header color="blue-grey darken-4">
            <modal-title>Заказ № {{ selectedOrderNumber }}</modal-title>
          </modal-header>
          <modal-body>
            <!-- basket -->
            <tbl responsive striped>
              <tbl-head color="blue-grey" textWhite>
                <tr>
                  <th scope="col">№</th>
                  <th scope="col">Код</th>
                  <th scope="col">Артикул</th>
                  <th scope="col">Наименование</th>
                  <th scope="col">Количество</th>
                  <th scope="col">Отаток Трост</th>
                  <th scope="col">Остаток Коласа</th>
                </tr>
              </tbl-head>
              <tbl-body>
                <tr v-for="(item, index) in selectedOrder.Товары" :key="index">
                  <th>{{ index + 1 }}</th>
                  <th>{{ item.NomCode }}</th>
                  <th>{{ item.Articul }}</th>
                  <th>{{ item.NomNaim }}</th>
                  <th>{{ item.Quantity }}</th>
                  <th>{{ item.skladMain }}</th>
                  <th>{{ item.skladBelka }}</th>

                </tr>
                <tr>
                  <th>ИТОГО:</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th>{{ selectedOrder.SummaDokumenta }} {{ selectedOrder.Valuta }}</th>
                </tr>
                <tr>
                  <td colspan="6">КОММЕНТАРИЙ: {{ selectedOrder.Comment }}</td>
                </tr>
              </tbl-body>
            </tbl>
          </modal-body>
          <modal-footer class="d-flex justify-content-center">
            <div>
              <btn class="blue-grey darken-4" @click.native="showOrderModalInfotronic = false">Назад</btn>
              <btn class="blue-grey darken-4"
                @click.native="postOrderInfotronic(), showOrderModalInfotronic = false, showModalOrdersInfotronic = false, showBasket = true">
                Перенести в корзину</btn>
            </div>
          </modal-footer>
        </modal>
        <modal side position="bottom-right" removeBackdrop v-if="showLoginModal && $route.path !== '/Quiz'" cascade
          class="text-left animated fadeIn">

          <modal-header :close="false" class="blue-grey darken-2 white-text d-flex justify-content-center">
            <btn class="btn-sm btn-call cyan darken-1" @click.native="showLetter = true"><i
                class="fa-solid fa-envelope"> </i>
              Написать руководству</btn>

          </modal-header>
          <modal-body class="grey-text">
            <h4 class="title">
              <fa class="fa fa-lock" /> Введите логин и пароль
            </h4>
            <span>
              <input v-if="!fizlico" class="form-control form-control-lg" type="number" v-model="Login" label="Логин"
                placeholder="УНП" icon="user" validate error="wrong" success="right" />

              <input v-if="fizlico" class="form-control form-control-lg" type="text" v-model="Login" label="Логин"
                placeholder="УНП" icon="user" validate error="wrong" success="right" />
            </span>
            <span>
              <input class="form-control form-control-lg" type="password" v-model="Password" label="Пароль"
                placeholder="Пароль" validate error="wrong" success="right" />
            </span>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input cyan" id="rememberMe" v-model="rememberMe" checked>
              <label class="custom-control-label mt-3" for="rememberMe">Запомнить меня</label>

            </div>
            <div class="custom-control custom-checkbox">

              <input type="checkbox" class="custom-control-input cyan" id="fizlico" v-model="fizlico" checked>
              <label class="custom-control-label mt-3" for="fizlico">Я физлицо</label>
            </div>
          </modal-body>
          <modal-footer>
            <div>

              <btn title="Войти" class="btn-sm btn-call cyan accent-4" data-dismiss="modal"
                @click.native="firstLogin(UID)" authcolor="success"> <i class="fas fa-user-plus"> </i> Войти </btn>

            </div>
          </modal-footer>
        </modal>
        <modal position="bottom" size="lg" v-if="showModal" @close="showModal = false">
          <modal-header>
            <modal-title>{{ selectedContragent.Kontragent }}</modal-title>
          </modal-header>
          <modal-body v-if="просроченныйДолг === 0" class="col-md-12 text-center">
            Общий долг: <b>{{ долг }} {{ selectedContragent.priceCurrency }}</b>
            Просроченный:<b>{{ просроченныйДолг }} {{ selectedContragent.priceCurrency }}</b>
          </modal-body>
          <modal-body v-if="просроченныйДолг > 0" class="col-md-12 text-center">
            Общий долг: <b>{{ долг }} {{ selectedContragent.priceCurrency }}</b> Просроченный: <b>
              <font color="red">{{ просроченныйДолг }} {{ selectedContragent.priceCurrency }}</font>
            </b>
          </modal-body>
          <modal-body>
            <template>
              <div v-if="долг > 0">
                <tbl responsive>
                  <tbl-head color="cyan darken-1" textWhite>
                    <tr>
                      <th>№</th>
                      <th>Дата</th>
                      <th>Сумма к оплате</th>
                      <th>Дней отсрочки</th>
                      <th>Дней до оплаты</th>
                    </tr>
                  </tbl-head>
                  <tbl-body v-for="(накладная, index) in накладные" :key="index">
                    <tr>
                      <th scope="row">{{ накладная.NUM }}</th>
                      <td>{{ накладная.Date | moment("DD-MM-YYYY") }}</td>
                      <td v-if="накладная.ДнейДоОплаты >= 0">{{ Math.round(накладная.Summa * 100) / 100 }}
                        {{ накладная.Valuta }}</td>
                      <td v-if="накладная.ДнейДоОплаты < 0"><b>
                          <font color="red">{{ Math.round(накладная.Summa * 100) / 100 }} {{ накладная.Valuta }}</font>
                        </b></td>
                      <td>{{ накладная.DneyOtsrochki }}</td>
                      <td v-if="накладная.ДнейДоОплаты > 0">{{ накладная.ДнейДоОплаты }}</td>
                      <td v-if="накладная.ДнейДоОплаты <= 0"><b>
                          <font color="red">{{ накладная.ДнейДоОплаты }}</font>
                        </b></td>
                    </tr>
                  </tbl-body>
                </tbl>
              </div>
            </template>
          </modal-body>
          <modal-footer class="d-flex justify-content-around">
            <btn color="cyan darken-1" @click.native="showModal = false">Закрыть</btn>
          </modal-footer>
        </modal>
        <modal position="bottom" size="lg" v-if="showBonusModal" @close="showBonusModal = false">
          <modal-header>
            <modal-title>{{ selectedContragent.Kontragent }}</modal-title>
          </modal-header>
          <div class="row">
            <div class="column">
              <img src="https://b2.belca.by/images/Actions/actionModal1.png" height="300" class="ml-5 mt-1 mb-1"
                alt="Акция">
            </div>
            <div class="column">
              <modal-body class="col-md-12 text-center">
                <b>Ваши текущие результаты в акции "1.U - тонер №1"</b>
              </modal-body>
              <modal-body v-if="bonus.filter(client => client.UNP === selectedContragent.UNP).length > 0"
                class="col-md-12 text-center p-1">
                Сумма закупок по акции: <b>{{ Prodano }}</b> у.е. с НДС
              </modal-body>
              <modal-body v-if="bonus.filter(client => client.UNP === selectedContragent.UNP).length > 0"
                class="col-md-12 text-center p-1">
                Процент накопительной скидки <b>{{ ProcentVipolneniya }}</b>%<br>
              </modal-body>
              <modal-body v-if="bonus.filter(client => client.UNP === selectedContragent.UNP).length > 0"
                class="col-md-12 text-center p-1">
                Сумма накопительной скидки <b>{{ SummaSkidki }}</b> у.е.<br>
              </modal-body>
              <modal-body v-if="bonus.filter(client => client.UNP === selectedContragent.UNP).length > 0"
                class="col-md-12 text-center p-1">
                Количество призовых банок тонера <b>{{ KolBanok }}</b> шт<br>
              </modal-body>
            </div>
          </div>
          <modal-footer class="d-flex justify-content-around">
            <btn color="cyan darken-1" @click.native="showBonusModal = false">Закрыть</btn>
          </modal-footer>
        </modal>
        <modal size="lg" v-if="showLetter">
          <modal-header class="blue-grey darken-3 white-text" @close="showLetter = false">
            <modal-title>Написать руководству</modal-title>
          </modal-header>
          <modal-body>
            <div class="row">
              <div class="col">

              </div>
              <div class="col">
                <!-- Group of default radios - option 3 -->
                <!-- Group of default radios - option 4 -->

              </div>
            </div>
            <!-- Default form contact -->
            <form>
              <!-- Default input name -->
              <label for="defaultFormContactNameEx" class="grey-text">Имя:</label>
              <input v-model="LetterName" type="text" id="defaultFormContactNameEx" class="form-control">

              <br>

              <!-- Default input subject -->
              <label for="defaultFormContactSubjectEx" class="grey-text">Телефон:</label>
              <input v-model="LetterPhone" type="tel" id="defaultFormContactSubjectEx" class="form-control">

              <br>

              <!-- Default textarea message -->
              <label for="defaultFormContactMessageEx" class="grey-text">Сообщение:</label>
              <div class="form-group">
                <textarea v-model="LetterText" class="form-control" id="exampleFormControlTextarea1"
                  rows="3"></textarea>
              </div>
            </form>
          </modal-body>
          <modal-footer>
            <btn class="blue-grey darken-4" @click.native="showLetter = false">Назад</btn>
            <btn class="cyan accent-4" @click.native="sendLetter(), showLetter = false">Отправить</btn>
          </modal-footer>
        </modal>
      </main>
    </template>
  </div>
</template>
<script>
import {
  Badge,
  Container,
  Navbar,
  NavbarItem,
  NavbarNav,
  NavbarCollapse,
  Btn,
  Fa,
  ListGroup,
  ListGroupItem,
  CardBody,
  Footer,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
  Tooltip,
  Popover,
  MdTextarea,
  Row,
  Column,
  Tbl,
  TblHead,
  TblBody,
  Carousel,
  CarouselItem,
  CarouselCaption
} from 'mdbvue'
import Catalog from './components/Catalog'
import Basket from './components/Basket'
import CRM from './components/CRM'
import Login from './components/Login'
import Sales from './components/Sales'
import Order from './components/Order'
import Chat from './components/Chat'
// import Sidebar from './components/Sidebar'
import ApiService from '@/services/ApiService'
import format from 'date-fns/format'
// import addDays from 'date-fns/add_days'
// import subDays from 'date-fns/sub_days'
import differenceInDays from 'date-fns/difference_in_days'
import subMonths from 'date-fns/sub_months'
import { addDays, subDays } from 'date-fns'
// import XlsxRead from 'vue-xlsx'
// import XlsxJson from '../../dist/vue-xlsx.es.js'
import { XlsxRead, XlsxJson } from 'vue-xlsx/dist/vue-xlsx.es.js'
// import { event } from 'jquery'

// import axios from 'axios'
export default {
  name: 'B2BTemplate',
  components: {
    XlsxRead,
    XlsxJson,
    Badge,
    Container,
    Navbar,
    NavbarItem,
    NavbarNav,
    NavbarCollapse,
    Btn,
    ListGroup,
    ListGroupItem,
    Fa,
    CardBody,
    'ftr': Footer,
    Catalog,
    Basket,
    Sales,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Tooltip,
    Popover,
    MdTextarea,
    Row,
    Column,
    Tbl,
    TblHead,
    TblBody,
    Login,
    Chat,
    CRM,
    Order,
    Carousel,
    CarouselItem,
    CarouselCaption

  },
  data () {
    return {
      collection: null,
      authorized: false,
      file: null,
      specialOrders: [],
      specialOrdersGlobal: [],
      specialOrdersSync: [],
      specialOrdersManager: [],
      selectedSpecialOrder: '',
      prihod: 0,
      plan: [],
      bonus: [],
      bonusPercent1: 0,
      bonusPercent2: 0,
      bonusPercent3: 0,
      bonusPercent4: 0,
      bonusPercent5: 0,
      dateFormat: 'DD-MM-YYYY',
      dateFormat1: 'YYYY-MM-DD H:mm:ss',
      orderedOnly: true,
      orderFilter: 'All',
      deliverySchemes: [],
      selectedSchema: '09575470-60c2-11e7-ac65-001dd8b723ef',
      activeItem: 1,
      activeOrder: 0,
      catalogAnimated: 5,
      client: '',
      SelectedClient: [],
      SelectedClientUNP: [],
      good: '',
      qty: '',
      sklad: 0,
      type: 0,
      status: 0,
      supplier: 0,
      Login: '',
      Password: '',
      priceType: '',
      partnersDebt: false,
      salesReady: false,
      orderReady: false,
      chatReady: false,
      temporder: [],
      ai: 0,
      oi: 0,
      info: null,
      updatedChart: false,
      oldReserves: 0,
      loading: true,
      spinner: false,
      LetterName: '',
      LetterPhone: '',
      LetterText: '',
      maxnumber: 0,
      mng: false,
      boss: false,
      mover: false,
      balance: [],
      rateEUR: 1,
      rateUSD: 1,
      rememberMe: true,
      fizlico: false,
      managers: [],
      activeMng: [],
      currencyRates: [],
      b2bOrders: 0,
      b2bOrdersTotal: 0,
      selectedManager: [],
      PriceSQ: [],
      foldersSQ: [],
      orders: [],
      ordersInfotronic: [],
      selectedOrder: [],
      goods: [],
      prices: [],
      sprecPrices: [],
      basket: [],
      basketTotal: 0,
      stock: [],
      search: '',
      searchGlobal: '',
      suppliers: {
        0: 'ВСЕ',
        1: 'СЛУЧАЙНЫЙ',
        2: 'СЕТ',
        3: 'КиП',
        4: 'Булат/ 7Q',
        5: 'Рамис',
        6: 'РМ',
        7: 'Колортек',
        8: 'ЗипЗИп',
        9: 'МАМОНТ',
        10: 'Ресурс Медиа',
        11: 'Оптикарт',
        12: 'Бигцмык',
        13: 'Файлер Мастер',
        14: 'ВТТ',
        15: 'а1Тис',
        16: 'Снами',
        17: 'Нереида',
        18: 'Артронас',
        19: 'Белхард',
        20: 'Канцмашины',
        21: 'Сдлайф (корп стандарт)',
        22: 'Бизнес Акила Плюс',
        23: 'Асбис',
        24: 'Байпринт',
        25: 'Спринкс',
        26: 'Принтлюкс',
        27: 'Шаргуд',
        28: 'АРАД',
        29: 'Будаев',
        30: 'Побач',
        31: 'Принттехника',
        32: 'Все про офис',
        33: 'Копиклаб',
        34: 'Копимедиа (КМГ)',
        35: 'Инкор',
        36: 'Изипринт',
        37: 'Мартел',
        38: 'Центр обслуживания оргтехники',
        39: 'Элпай',
        40: 'Троцкий',
        41: 'Штайгертех',
        42: 'Копирка бай',
        43: 'Трайдекс бел',
        44: 'Мипс',
        45: 'НордПринт',
        46: 'Приоритет Качества',
        47: 'Гига маркет',
        48: 'Саулюс',
        49: 'Биуро',
        50: 'Лига Тим',
        51: 'Скорпион',
        52: 'Германия'
      },
      specialOrdersSupplier: 0,
      specialOrdersStatus: 0,
      specialOrdersStatusList: {
        0: 'ВСЕ',
        1: 'Новый',
        2: 'Запросила',
        3: 'Обработан',
        4: 'Везти',
        5: 'Заказан',
        6: 'Отменен',
        7: 'Прибыл',
        8: 'Удалить'
      },
      specialOrdersTypeList: {
        0: 'ВСЕ',
        1: 'РБ-РФ',
        2: 'СЕТ',
        3: 'Европа'
      },
      specialOrdersSkladList: {
        0: 'Минск',
        1: 'Москва'
      },
      json_fields_Special: {
        '№': 'number',
        'Версия': 'version',
        'Дата': 'date',
        'Менеджер': 'manager',
        'Клиент': 'client',
        'УНП': 'UNP',
        'Товар': 'good',
        'Количество': 'quantity',
        'Цена': 'price',
        'Ответ': 'response',
        'Срок': 'term',
        'Склад': 'sklad',
        'Тип': 'type',
        'Поставщик': 'supplier',
        'Статус': 'status',
        '№ заказа': 'ordernumber'
      },
      specialOrdersType: 0,
      specialOrdersSklad: 0,
      contragents: [],
      businessRegions: [],
      dateOne: this.startDate,
      dateTwo: this.endDate,
      salesSubMode: 'Empty',
      selectedContragentDescription: '',
      selectedContragent: '',
      selectedContragentName: '',
      selectedContragentManager: '',
      selectedContragentBasket: [],
      selectedContragentBalance: 0,
      selectedOrderNumber: '',
      selectedPartner: '',
      selectedPartnerAnalytics: '',
      showPercent: true,
      showModalGlobalSearch: false,
      showLetter: false,
      supplierOrder: false,
      showModalOrders: false,
      showModalOrdersInfotronic: false,
      showModalSpecialOrders: false,
      showLoginModal: false,
      showOrderModal: false,
      showOrderModalInfotronic: false,
      showBonusModal: false,
      supplierTransit: null,
      supplierInvoice: null,
      specialOrdersFiles: [],
      showModal: false,
      sideClosed: false,
      showFavs: false,
      goodsInfotronic: [],
      goodsInfotronic1C: [],
      favkey: 0,
      startDate: new Date(),
      endDate: subDays(new Date(), 7),
      user: [],
      partnerABCXYZ: [],
      partnersABCXYZ: [],
      comment: '',
      долг: 0,
      просроченныйДолг: 0,
      непросроченныйДолг: 0,
      максДнейПросрочки: 0,
      отсрочка: 0,
      накладные: [],
      bbIndex: 0,
      showBasket: false,
      showCRM: false,
      selectedContragentFav: [],
      folders: [],
      coordinates: [],
      managersSales: [],
      managerSales: [],
      managerSalesTotal: [],
      partnerSales: [],
      partnersSales: [],
      partnerSalesTotal: [],
      partnersSalesByGoods: [],
      partnerSalesByGoods: [],
      partnerSalesByGoodsExport: [],
      partnerSalesByGroups: [],
      partnerSalesByGroupsExport: [],
      partnersSalesByPeriod: [],
      partnersSalesByPeriodShort: [],
      folder0: '00000000001',
      folder1: '00000000001',
      folder2: '00000000001',
      hidebasket: true,
      UID: ''
    }
  },
  watch: {
    authorized () {
      if (this.authorized) this.showLoginModal = false
    }

  },
  methods: {
    highstatus (status) {
      console.log('status ' + status)
      if (status > 4) return true
      else return false
    },
    globalSearch () {
      this.getSpecialOrdersListGlobal()
      this.showModalGlobalSearch = true
      // if (this.filteredListSpecialOrdersGlobal.length > 0)
    },
    findNonUniqueValues (arr, key, unpKey) {
      let uniqueValues = new Map()
      let nonUniqueValues = new Map()

      for (let i = 0; i < arr.length; i++) {
        if (uniqueValues.has(arr[i][key])) {
          if (uniqueValues.get(arr[i][key]) !== arr[i][unpKey]) {
            nonUniqueValues.set(arr[i][key], [uniqueValues.get(arr[i][key]), arr[i][unpKey]])
          }
        } else {
          uniqueValues.set(arr[i][key], arr[i][unpKey])
        }
      }

      return nonUniqueValues
    },
    updateSklad (value, order) {
      this.sklad = parseInt(value)
      // console.log(value)
      order.data.forEach(item => {
        var suborder = this.specialOrders.filter(suborder => suborder.guid === item.guid)
        suborder[0].sklad = parseInt(value)
        console.log(value)
      })
    },
    updateClient (value, order) {
      this.client = value
      // console.log(value)
      order.data.forEach(item => {
        var suborder = this.specialOrders.filter(suborder => suborder.guid === item.guid)
        suborder[0].client = value
        suborder[0].date = this.formatDate1(new Date())
        console.log(value)
      })
    },
    updateClientUNP (value, order) {
      console.log('Update ClientUNP')

      this.СlientUNP = value
      order.data.forEach(item => {
        var suborder = this.specialOrders.filter(suborder => suborder.guid === item.guid)
        suborder[0].ClientUNP = value
        suborder[0].date = this.formatDate1(new Date())
        console.log(value)
      })
    },
    updateGood (value, order) {
      this.good = value
      // console.log(value)
      order.data.forEach(item => {
        var suborder = this.specialOrders.filter(suborder => suborder.guid === item.guid)
        suborder[0].good = value
        suborder[0].date = this.formatDate1(new Date())
        console.log(value)
      })
    },
    updateQty (value, order) {
      this.qty = value

      order.data.forEach(item => {
        var suborder = this.specialOrders.filter(suborder => suborder.guid === item.guid)
        if (suborder.length > 0) {
          if (suborder[0].status < 4) {
            suborder[0].quantity = value
            suborder[0].date = this.formatDate1(new Date())
            console.log(value)
          } else {
            this.$dialog.alert('Нельзя менять количество в обработанном заказе! Создайте новый. ').then(function (dialog) {
            })
          }
        }
      })
    },
    updateType (value, guid) {
      this.type = parseInt(value)
      var suborder = this.specialOrders.filter(suborder => suborder.guid === guid)
      console.log(suborder)
      console.log('Update Type')
      if (suborder.length > 0) {
        suborder[0].type = parseInt(value)
        suborder[0].date = this.formatDate1(new Date())
        console.log(value)
      }
    },
    updateSupplier (value, guid) {
      console.log('Update Supplier')
      this.supplier = parseInt(value)
      var suborder = this.specialOrders.filter(suborder => suborder.guid === guid)
      console.log(suborder)
      if (suborder.length > 0) {
        suborder[0].supplier = this.supplier
        suborder[0].date = this.formatDate1(new Date())
        console.log(value)
      }
    },
    selectSpecialOrder (guid) {
      this.selectedSpecialOrder = guid
      console.log('Selected guid ', guid)
      /*
      var selectedOrder = this.specialOrders.filter(order => order.guid === guid)
      if (selectedOrder.length > 0) {
        console.log('Selected guid ', guid)
        this.client = selectedOrder[0].client
        this.good = selectedOrder[0].good
        this.qty = selectedOrder[0].quantity
        this.type = selectedOrder[0].type
        this.status = selectedOrder[0].status
      }
*/
      // console.log(guid)
    },
    async handleParsed (parsedData) {
      // console.log(parsedData) // Обработка данных после парсинга
      parsedData.forEach(line => {
        this.specialOrders.push({
          number: '',
          version: 0,
          guid: this.generateGuid(),
          date: this.formatDate1(new Date()),
          manager: this.activeMng.ManagerCode,
          client: line.Клиент,
          UNP: this.Login,
          good: line.Товар,
          quantity: line.Количество,
          price: '',
          response: '',
          term: '',
          sklad: 0,
          type: parseInt(line.Тип),
          supplier: 0,
          status: 1,
          ordernumber: ''
        })
        console.log(line)
      })
      var orderfile = JSON.stringify(this.specialOrders)
      var res = await ApiService.writeSpecialOrderFile(this.Login, orderfile)
      console.log(res.status)
      this.$dialog.alert('Заказы из файла успешно импортированы и сохранены! ').then(function (dialog) {
      })
      this.file = null
      console.log(this.file)
    },
    onChange (event) {
      this.file = event.target.files ? event.target.files[0] : null
      // console.log(JSON.stringify(this.file))
    },
    apply () {
      console.log(this.dateOne + ' ' + this.dateTwo)
      // console.log('DateSelected', {dateone: this.dateOne, datetwo: this.dateTwo})
      this.startDate = this.dateOne
      this.endDate = this.dateTwo
      if (this.dateOne === '') {
        this.dateOne = this.datetwo
      }
    },
    formatDates (dateOne, dateTwo) {
      let formattedDates = ''
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat)
      }
      if (dateTwo) {
        formattedDates += ' - ' + format(dateTwo, this.dateFormat)
      }
      return formattedDates
    },
    finishDownloadSpecial () {
      this.excelReady = true
      console.log('Excel created')
      this.$emit('loaded')
      this.file = null
    },
    async changeStatus (value, guid) {
      this.temporder = []
      this.temporder = this.specialOrders.filter(order => order.guid === guid)
      await this.getSpecialOrderList()
      this.status = parseInt(value)
      var ordermodified = this.specialOrders.filter(order => order.guid === guid)
      if (this.status >= ordermodified[0].status) {
        if (ordermodified.length > 0) {
          ordermodified[0].status = this.status
          ordermodified[0].date = this.formatDate1(new Date())
          console.log('ИЗМЕНИЛИ СТАТУС существующего заказа ', guid, ' на', value)
          ordermodified[0].status = this.status
        } else if (ordermodified.length === 0) {
          console.log('Не сохранен')
          this.temporder[0].status = this.status
          this.specialOrders.push(this.temporder[0])
          console.log(this.temporder[0])
          ordermodified = this.temporder
        }

        var manager = ''
        let status = 0
        try {
          status = await this.writeSpecialOrderFile()
          console.log(status)
        } catch (error) {
          console.error('Error:', error)
          this.errorMessage = 'Ошибка при загрузке файла. Отсутствует связь с сервером. Несколько последних изменений могут не сохраниться!'
          alert(this.errorMessage)
        }
        if (status === 200) {
          if (parseInt(ordermodified[0].status) === 4) {
            if (parseInt(ordermodified[0].type) === 1) manager = 'Алина Ефименко'
            if (parseInt(ordermodified[0].type) === 2) manager = 'Ольга Беленко'
            if (parseInt(ordermodified[0].type) === 3) manager = 'Елена Волкова'
            var mess = '<b>' + ordermodified[0].date + '</b> - ' + 'cпецзаказ № <b>' + ordermodified[0].number + '-' + ordermodified[0].version + '</b>' + ' от ' + ordermodified[0].manager + ' получил статус <b>ВЕЗТИ</b>'
            var res = await ApiService.sendTelegramNotification(manager, mess)

            console.log('Запись ', status, ' Сообщение', res)
          }
          if (parseInt(ordermodified[0].status) === 6) {
            if (parseInt(ordermodified[0].type) === 1) manager = 'Алина Ефименко'
            if (parseInt(ordermodified[0].type) === 2) manager = 'Ольга Беленко'
            if (parseInt(ordermodified[0].type) === 3) manager = 'Елена Волкова'
            var mess1 = '<b>' + ordermodified[0].date + '</b> - ' + 'cпецзаказ № <b>' + ordermodified[0].number + '-' + ordermodified[0].version + '</b>' + ' от ' + ordermodified[0].manager + ' получил статус <b>ОТМЕНЕН</b>'
            var res1 = await ApiService.sendTelegramNotification(manager, mess1)

            console.log('Запись ', status, ' Сообщение', res1)
          }
        } else {
          this.$dialog.alert('Не получилось сохранить изменения! Обновите статусы и попробуйте еще раз!').then(function (dialog) {
          })
        }
      } else if (this.status < ordermodified[0].status) {
        this.$dialog.alert('Не получилось сохранить изменения! Нельзя понижать статус заказа!').then(function (dialog) {
        })
      }
    },
    async fetchDataSpecial () {
      this.$emit('load')
      this.excelReady = false
      this.excelData = []
      for (let ind = 0; ind < this.filteredListSpecialOrders.length; ind++) {
        this.excelData[ind] = {}
        this.excelData[ind].number = this.filteredListSpecialOrders[ind].number
        this.excelData[ind].version = this.filteredListSpecialOrders[ind].version
        this.excelData[ind].guid = this.filteredListSpecialOrders[ind].guid
        this.excelData[ind].date = this.filteredListSpecialOrders[ind].date
        this.excelData[ind].manager = this.filteredListSpecialOrders[ind].manager
        this.excelData[ind].client = this.filteredListSpecialOrders[ind].client
        this.excelData[ind].UNP = this.filteredListSpecialOrders[ind].UNP
        this.excelData[ind].good = this.filteredListSpecialOrders[ind].good
        this.excelData[ind].quantity = this.filteredListSpecialOrders[ind].quantity
        this.excelData[ind].price = this.filteredListSpecialOrders[ind].price
        this.excelData[ind].response = this.filteredListSpecialOrders[ind].response
        this.excelData[ind].term = this.filteredListSpecialOrders[ind].term
        this.excelData[ind].sklad = this.specialOrdersSkladList[this.filteredListSpecialOrders[ind].sklad]
        this.excelData[ind].type = this.specialOrdersTypeList[this.filteredListSpecialOrders[ind].type]
        this.excelData[ind].supplier = this.suppliers[this.filteredListSpecialOrders[ind].supplier]
        this.excelData[ind].status = this.specialOrdersStatusList[this.filteredListSpecialOrders[ind].status]
        this.excelData[ind].ordernumber = this.filteredListSpecialOrders[ind].ordernumber
      }

      return this.excelData
    },
    debounceSearch (event) {
      // this.search = ''
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.search = event.target.value
      }, 500)
    },
    debounceClean () {
      this.search = ''
      this.$refs.inp.value = ''
      // console.log(this.$refs.inp.value)
    },
    debounceSearchGlobal (event) {
      // this.search = ''
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.searchGlobal = event.target.value
      }, 500)
    },
    debounceCleanGlobal () {
      this.searchGlobal = ''
      this.$refs.inp.value = ''
      // console.log(this.$refs.inp.value)
    },
    async writeSpecialOrderFile () {
      console.log('Write srecialOrder file ')

      var orderfile = JSON.stringify(this.specialOrders)
      var res = ''
      try {
        res = await ApiService.writeSpecialOrderFile(this.Login, orderfile)
      } catch (error) {
        console.error('Error:', error)
        this.errorMessage = 'Ошибка при записи файла. Отсутствует связь с сервером. Несколько последних изменений могут не сохраниться!'
        alert(this.errorMessage)
      }
      console.log('Статус:' + res.status)
      if (parseInt(res.status) === 200) {
        this.$dialog.alert('Заказ сохранен!').then(function (dialog) {
        })
      }
      return (parseInt(res.status))
    },
    async deleteSpecialOrder (guid) {
      console.log(guid)
      // Поиск элемента с заданными значениями uid и version
      this.specialOrders = this.specialOrders.filter(item => item.guid !== guid)
      // console.log('indexToRemove ', indexToRemove)
      // Удаление элемента, если он найден
      // var orderfile = JSON.stringify(this.specialOrders)
      this.writeSpecialOrderFile(this.Login)
      console.log('Delete complete! Write srecialOrder file ')
      this.deleteSpecialOrderManager(this.Login, guid)

      // console.log(JSON.stringify(this.specialOrders))
    },
    async deleteSpecialOrderManager (UNP, guid) {
      console.log('Deleting order from Manager file...', guid)
      // Поиск элемента с заданными значениями uid и version
      let indexToRemove = this.specialOrdersManager.findIndex(item => item.guid === guid)

      // Удаление элемента, если он найден
      if (indexToRemove !== -1) {
        this.specialOrdersManager.splice(indexToRemove, 1)
        var orderfile = JSON.stringify(this.specialOrdersManager)
        await ApiService.writeSpecialOrderFileManager(UNP, orderfile)
        console.log('Delete complete! Write srecialOrder file ')
      }
      // console.log(JSON.stringify(this.specialOrdersManager))
      indexToRemove = this.specialOrders.findIndex(item => item.guid === guid)

      // Удаление элемента, если он найден
      if (indexToRemove !== -1) {
        this.specialOrders.splice(indexToRemove, 1)
        orderfile = JSON.stringify(this.specialOrders)
        await ApiService.writeSpecialOrderFileManager(UNP, orderfile)
        console.log('Delete complete! Write srecialOrder file ')
      }
      // console.log(JSON.stringify(this.specialOrdersManager))
    },
    async postOrderInfotronic () {
      // this.selectedContragentBasket = []
      // this.selectedContragentBasket = {...}
      // this.selectedOrder.Товары.forEach(good => this.addGood(good))
      // console.log('addGood ' + good.NomCode)
      // console.log('addGood ' + good.Quantity)
      // console.log('addGood ' + good.Price)
      // var itemfound = this.goods.filter(basketgood => (basketgood.NomCode === good.NomCode))
      // if (itemfound.length === 1) { itemfound[0].Quantity = good.Quantity }
      // console.log('itemfound ' + itemfound.length)
      // if (good.Quantity !== '' && itemfound.length !== 1) { await this.getClientBasket(this.selectedContragent.UNP) }
      this.selectedContragentBasket = this.selectedOrder.Товары
      var order = JSON.stringify(this.selectedContragentBasket)
      // console.log('order ' + order)
      var res = await ApiService.putOrderFile(this.selectedContragent.UNP, order)
      // var goodstr = JSON.stringify(res)
      console.log('addGood ' + res)
    },
    changeSalesSubMode (event) {
      //     console.log(event)
      this.salesSubMode = event
      this.spinner = true
    },
    countDown () {
      if (this.catalogAnimated) {
        return setTimeout(() => {
          --this.catalogAnimated
          this.countDown()
        }, 1000)
      }
    },
    async load () {
      await new Promise(resolve => setTimeout(resolve, 1))
      this.spinner = true
      //     console.log('Spinner ', this.spinner)
    },
    async loaded () {
      await new Promise(resolve => setTimeout(resolve, 1))
      this.loading = false
      // this.spinner = false
    },
    async spinneroff () {
      await new Promise(resolve => setTimeout(resolve, 1))
      this.spinner = false
      console.log('Spinner off', this.spinner)
    },
    getQty (price, sum) {
      price = price.replace(' ', '')
      price = price.replace(',', '.')
      price = Number(price)
      // console.log('price:', price)
      // console.log('sum:', sum)
      var sum1 = parseFloat(sum.replace(',', '.').replace(/[^0-9.]/gim, ''))
      // console.log('sum:', sum1)

      return Math.round(sum1 / price)
    },
    async showOrder (orderNumber) {
      let response = await ApiService.getOrder(orderNumber)
      if (response.status === 200) this.selectedOrder = response.data
      this.showOrderModal = true
      this.selectedOrderNumber = orderNumber
      // console.log(orderNumber)
    },
    async showOrderInfotronic (orderNumber) {
      this.selectedOrder = this.ordersInfotronic.filter(item => item.Number === orderNumber)[0]
      this.showOrderModalInfotronic = true
      this.selectedOrderNumber = orderNumber
      this.selectedOrder.Товары.forEach(good => {
        var Articul = this.goodsInfotronic1C.filter(item => item.Ref_Key === good.Номенклатура_Key)
        // console.log(Articul)

        good.Articul = Articul[0].Артикул
        var NomCode = this.goodsInfotronic.filter(item => item.Articul === good.Articul)
        // console.log(NomCode)
        if (NomCode.length !== 0) {
          good.NomCode = NomCode[0].Code
          var NomNaim = this.goodsInfotronic.filter(item => item.Code === good.NomCode)
          // console.log(NomNaim)
          good.NomNaim = NomNaim[0].Naim
        } else {
          good.NomCode = 'НЕ БЕЛКА'
          good.NomNaim = 'НЕ БЕЛКА'
        }

        good.Quantity = good.Количество
        var item = this.goods.filter(item => item.NomCode === good.NomCode)
        if (item.length > 0) {
          good.skladMain = item[0].skladMain
          good.skladBelka = item[0].skladBelka
        } else {
          good.skladMain = 0
          good.skladBelka = 0
        }
        // console.log(item)
      })
      // console.log(orderNumber)
    },
    async getBonus () {
      console.log('Bonuses')
      // let response = await ApiService.getPlan()
      // if (response.status === 200) this.plan = response.data
      // this.plan.forEach(el => { el.UNP = el.UNP.trim() })
      let response1 = await ApiService.getBonus()
      if (response1.status === 200) this.bonus = response1.data

      this.bonus.sort((a, b) => {
        let fa = a.Summa
        let fb = b.Summa
        if (fa < fb) {
          return 1
        }
        if (fa > fb) {
          return -1
        }
        return 0
      })

      this.bonus.forEach(element => {
        element.UNP = element.UNP.trim()
        let cl = this.contragents.filter(item => item.UNP.trim() === element.UNP.trim())
        if (cl.length > 0) {
          cl[0].UNP = cl[0].UNP.trim()

          element.Kontragent = cl[0].Kontragent
        } else element.Kontragent = 'Нет в b2b'
        // if (element.UNP.trim() === '193625748') console.log(element)
      })

      // this.bonusPercent1 = Math.round(this.bonus[0].ProcentVipolneniya)
      // this.bonusPercent2 = Math.round(this.bonus[1].ProcentVipolneniya)
      // this.bonusPercent3 = Math.round(this.bonus[2].ProcentVipolneniya)
      // this.bonusPercent4 = Math.round(this.bonus[3].ProcentVipolneniya)
      // this.bonusPercent5 = Math.round(this.bonus[4].ProcentVipolneniya)

      // console.log(this.bonus)

      // console.log(orderNumber)
    },
    async sendLetter () {
      let answer = await ApiService.sendSiteLetter(this.LetterName, this.LetterPhone, this.LetterText)
      console.log(answer.status)
      if (answer.status === 200) {
        this.$dialog.alert('Ваше сообщение успешно отправлено!').then(function (dialog) {
        })
      }
    },
    formatDate (date) {
      let formattedDates = ''
      formattedDates = format(date, this.dateFormat)
      return formattedDates
    },
    formatDate1 (date) {
      let formattedDates = ''
      formattedDates = format(date, this.dateFormat1)
      return formattedDates
    },
    orderCreated () {
      this.supplierOrder = false
    },
    formatPhoneNumber (phone) {
      var tt = phone.split('')
      tt.splice(4, '', ' (')
      tt.splice(7, '', ') ')
      tt.splice(11, '', ' ')
      tt.splice(14, '', ' ')
      return (tt.join(''))
    },
    getVendorCode (productName) {
      const vendorTable = {
        '7Q': ['BT'],
        'ALP': ['AP'],
        'APEX': ['AC'],
        'BULAT': ['BT'],
        'БУЛАТ': ['BT'],
        'R-LINE': ['BT'],
        'S-LINE': ['BT'],
        'E-LINE': ['BT'],
        'CET': ['CT'],
        'COLORTEK': ['CK'],
        'DPT': ['DP'],
        'EASY': ['ET'],
        'FUJI': ['FU'],
        'GALA': ['GP'],
        'GOLDEN': ['GG'],
        'HANDAN': ['HN'],
        'HI': ['HB'],
        'IMEX': ['IM'],
        'INK-MATE': ['IE'],
        'INTEGRAL': ['IL'],
        'IPM': ['IP'],
        'JADI': ['JD'],
        'KATUN': ['KA'],
        'MURATA': ['MR'],
        'OCP': ['OP'],
        'RITE': ['PR'],
        'GALAPRINT': ['RM'],
        'ATM': ['RS'],
        'STATIC': ['SC'],
        'SC': ['SC'],
        'TECH': ['PT'],
        'TOMOEGAWA': ['TG'],
        'TMS': ['TS'],
        'UNITON': ['UN'],
        'WHITE': ['WE']
      }
      const words = productName.toUpperCase().split(' ')
      let vendorCode = 'NN'
      for (let i = 0; i < words.length; i++) {
        const word = words[i]
        for (const vendorName in vendorTable) {
          if (vendorTable.hasOwnProperty(vendorName)) {
            if (vendorName.indexOf(word) !== -1) {
              vendorCode = vendorTable[vendorName][0]
              break
            }
          }
        }
        if (vendorCode !== 'NN') {
          break
        }
      }
      return vendorCode
    },
    /*
    async mngProcedures () {
      console.log('mngProcedures')
      this.mng = true
      // this.checkip()
      await this.getContragents()
      this.exchangeRateUSD()
      await this.getManagers()
      this.exchangeRate()
      this.authorized = true
      this.getDeliverySchemes()
      this.getPartnersSalesPeriodShort()
      this.getPartnersSalesByYearByGoods()
      this.getBusinessRegions()
      this.getPartnersSalesByYear()
      this.getManagersSalesByYear()
      this.getPartnerABCXYZ(this.selectedPartner)
      // this.copyOrderToBasket()
      // await this.selectContragent('')
      // await this.getClientBalance()
    },

    async getDeliverySchemes () {
      console.log('DeliverySchemes')
      let answer = await ApiService.getDeliverySchemes()
      this.deliverySchemes = answer.data.value
      this.deliverySchemes[this.deliverySchemes.length] = { 'Description': 'Заказ глобальный', 'Ref_Key': '00000000-0000-0000-0000-000000000000' }
      // this.deliverySchemes[this.deliverySchemes.length]['Description'] = 'Заказ поставщикам Skorpiono'
      // this.deliverySchemes[this.deliverySchemes.length]['Ref_Key'] = '00000000-0000-0000-0000-000000000000'
      // console.log(this.deliverySchemes[this.deliverySchemes.length - 1])
    },
    getSupplierTransit (event) {
      // console.log('getSupplierTransit ' + event)
      // this.supplierTransit = event
      // this.supplierInvoice = event
    },
    getSupplierInvoice (event) {
      // console.log('getSupplierInvoice ' + event)
      // this.supplierInvoice = event
      // this.supplierTransit = event
    },
    */
    b2bOrdersUniq (event) {
      // console.log('b2bOrdersUniq ' + JSON.stringify(event))
      this.b2bOrders = event.uniq
      this.b2bOrdersTotal = event.total
    },
    getFolder0 (event) {
      //      console.log('getFolder0 ' + event)
      this.folder0 = event
      this.spinner = true
    },
    getFolder1 (event) {
      //    console.log('getFolder1 ' + event)
      this.folder1 = event
      this.spinner = true
    },
    getFolder2 (event) {
      //    console.log('getFolder2 ' + event)
      this.folder2 = event
      this.spinner = true
    },
    chngai: function (e) {
      console.log('CURRENT AI:', e)
      this.ai = e
      /*
      if (this.ai === 10) {
        this.startDate = format(subDays(Date(), 0), 'YYYY-MM-DD')
        this.endDate = format(subDays(Date(), 0), 'YYYY-MM-DD')
      }
      if (this.ai === 7) {
        this.startDate = format(subDays(Date(), 7), 'YYYY-MM-DD')
        this.endDate = format(subDays(Date(), 0), 'YYYY-MM-DD')
      }
      */
    },
    selectScheme (event) {
      console.log('selectScheme ' + event)
      this.goods.forEach((good) => {
        good.toOrder = ''
        good.sales60 = 0
        good.sales30 = 0
      })
      this.selectedSchema = event
    },
    async getPrices () {
      this.priceType = ''
      if (this.selectedContragent.Tip === 1) this.priceType = '000000107'
      else if (this.selectedContragent.Tip === 2) this.priceType = '000000009'
      else if (this.selectedContragent.Tip === 3) this.priceType = '000000105'
      else if (this.selectedContragent.Tip === 4 && this.selectedContragent.Priznak === 2) this.priceType = '000000111'
      else if (this.selectedContragent.Tip === 5) this.priceType = '000000006'
      else if (this.selectedContragent.Tip === 6 || (this.selectedContragent.Tip === 4 && this.selectedContragent.Priznak === 3)) { this.priceType = '000000114' }

      if (this.selectedContragent.Tip === 4 || this.selectedContragent.Tip === 6 || this.selectedContragent.Gorod === 'rf') this.selectedContragent.priceCurrency = 'RUB'
      else this.selectedContragent.priceCurrency = 'BYN'
      console.log(this.selectedContragent.Kontragent)

      const response1 = await ApiService.getPricesFile()
      this.prices = await response1.data
      this.prices.forEach((good) => {
        good.Cena = parseFloat(good.Cena.replaceAll(',', '.'))
      })

      // await new Promise(resolve => setTimeout(resolve, 10))
      // console.log('Спеццены - ' + this.selectedContragent.KodTipSpecCen)
      if (this.selectedContragent.KodTipSpecCen === '') { this.prices = this.prices.filter(price => price.TipCenCode === this.priceType) }
      if (this.selectedContragent.KodTipSpecCen !== '') {
        // console.log('Спеццены - ' + this.selectedContragent.KodTipSpecCen)
        this.sprecPrices = this.prices.filter(price => price.TipCenCode === this.selectedContragent.KodTipSpecCen)
        this.prices = this.prices.filter(price => price.TipCenCode === this.priceType)
      }
      if (this.sprecPrices.length > 0) {
        var kurs = this.currencyRates.filter(rate => rate.Valuta === this.sprecPrices[0].ValutaCode)
        // console.log('Курс', kurs)
        this.sprecPrices.forEach((spec) => {
          // console.log(spec)
          var goodprice = this.prices.filter(price => price.NomCode === spec.NomCode)
          if (goodprice.length === 1) {
            if (kurs.length === 1) {
              goodprice[0].Cena = Math.round((spec.Cena * kurs[0].Kurs / kurs[0].Kratnost) * 100) / 100
              // console.log(goodprice[0].Cena)
            }
          }
        })
      }
    },
    async selectContragent ($event) {
      console.log('SelectContragentEvent ' + $event)
      console.log('this.selectedContragent ' + JSON.stringify(this.selectedContragent))
      this.накладные = []
      this.просроченныйДолг = 0
      this.selectedContragentBalance = 0
      this.долг = 0

      this.selectedContragent.UNP = this.selectedContragent.UNP.trim()
      var res = this.contragents.filter(contragent => contragent.UNP === this.selectedContragent.UNP)
      if (res.length === 1) {
        this.selectedContragent = res[0]
        // this.selectedContragentName = this.selectedContragent.Kontragent
        // this.selectedContragent.priceCurrency = ''
      }
      console.log('this.selectedContragent ' + JSON.stringify(this.selectedContragent))
      this.$localStorage.set('selectedContragent', this.selectedContragent.UNP)
      this.getOrderList()
      await this.getPrices()

      this.authorized = true
      this.showLoginModal = false
      this.hidebasket = false
      this.user = {}
      this.user.mng = this.mng
      this.user.Login = this.Login
      this.user.selectedContragent = this.selectedContragent.UNP
      await this.getFavs()
      // this.$localStorage.set('Login', this.Login)
      // this.$localStorage.set('Password', this.Password)
      // const response4 = await ApiService.getStockFile()
      // await new Promise(resolve => setTimeout(resolve, 1000))
      /*
      this.stock = response4.data
      if (this.stock === null) {
        this.$dialog.alert('Конфликт блокировок! Зайдите через 5 минут.').then(function (dialog) {
        })
      }
      */
      var res1 = this.managers.filter(manager => manager.ManagerCode === this.selectedContragent.OsnmanagerCode)
      if (res1.length === 1) { this.selectedContragentManager = res1[0] }
      console.log('this.selectedContragentManager ' + JSON.stringify(this.selectedContragentManager))
      var res2 = this.balance.filter(contragent => contragent.UNP === this.selectedContragent.UNP)
      if (res2.length === 1) { this.selectedContragentBalance = res2[0].Summa }
      if (this.selectedContragentBalance > 0) {
        this.getContragentInvoices()
      }
      this.goods.forEach((good) => {
        good.Quantity = ''
      })
      this.selectedContragentBasket.splice(0, this.selectedContragentBasket.length)
      await this.getClientBasket(this.selectedContragent.UNP)
    },
    getKontragentName (UNP) {
      const contragent = this.contragents.find(c => c.UNP === UNP)
      return contragent ? contragent.Kontragent : ''
    },
    async getContragentInvoices () {
      this.долг = this.selectedContragentBalance
      const res = await ApiService.getContragentInvoices(this.selectedContragent.UNP)
      this.накладные = res.data
      // this.накладные.reverse()
      this.накладные.sort((a, b) => differenceInDays(format(b.Date, 'YYYY-MM-DD'), format(a.Date, 'YYYY-MM-DD')))
      // console.log(JSON.stringify(this.накладные))
      var sum = 0
      var endIndex = 0

      while (sum < this.selectedContragentBalance && endIndex < this.накладные.length) {
        sum += this.накладные[endIndex].Summa
        endIndex++
      }

      var result = this.накладные.slice(0, endIndex)
      if (sum > this.selectedContragentBalance) {
        result[endIndex - 1].Summa -= (sum - this.selectedContragentBalance)
        result[endIndex - 1].Summa = Math.round(result[endIndex - 1].Summa * 100) / 100
      }

      this.накладные = result
      this.просроченныйДолг = 0
      this.накладные.forEach((накладная) => {
        накладная.ДнейДоОплаты = differenceInDays(addDays(накладная.Date, накладная.DneyOtsrochki), Date())
        this.максДнейПросрочки = накладная.ДнейДоОплаты
        if (накладная.ДнейДоОплаты < 0) this.просроченныйДолг += накладная.Summa
      })

      this.просроченныйДолг = Math.round(this.просроченныйДолг * 100) / 100

      // console.log(JSON.stringify(this.накладные))
    },
    async DateSelected (event) {
      console.log('DATE SELECTED EVENT ', event)
      this.startDate = event.dateone
      this.endDate = event.datetwo
      if (event.dateone === '') {
        event.dateone = event.datetwo
      }
      if (this.ai === 7) {

      }
    },
    async exchangeRate () {
      const response = await ApiService.getExchangeRate()
      let data = response.data
      this.rateEUR = data.value[0].Курс
    },
    async exchangeRateUSD () {
      const response = await ApiService.getExchangeRateUSD()
      let data = response.data
      this.rateUSD = data.value[0].Курс
    },
    async CreateSupplierOrder () {
      console.log('CreateSupplierOrder - APP')
      this.supplierOrder = true
    },
    async infoContragent (event) {
      // console.log(event)
      // this.loading = true
      this.hidebasket = true
      console.log('Info contragent')
      // this.$bus.$emit('Contragent')
      // await this.auth(event)
      // console.log('from infocontragent, count ' + this.contragents.length)
      for (var i = 0; i < this.contragents.length; i++) {
        if (this.contragents[i].Ref_Key === event) {
          this.selectedContragent = this.contragents[i].Ref_Key
          this.selectedPartner = this.contragents[i].Партнер_Key
          this.selectedPartnerAnalytics = this.contragents[i].АналитикаУчетаПоПартнерам_Key
          this.selectedContragentDescription = this.contragents[i].Description
          break
        }
      }
      this.selectContragent(event)
      this.getPartnerSalesByYear(this.selectedPartnerAnalytics)
      this.getPartnerABCXYZ(this.selectedPartner)
      // this.$bus.$emit('partnerSalesByYear')
      this.getPartnerSalesByYearByGoods(this.selectedPartnerAnalytics)
      this.getPartnerSalesByYearByGroups(this.selectedPartnerAnalytics)
      this.showCRM = true
      this.$bus.$emit('Contragent')
      this.getClientBalance()
      // this.auth(this.selectedContragent)
    },
    selectManager (event) {
      var res = this.managers.filter(manager => manager.ManagerCode === event)
      // console.log('event ', event)
      // console.log('res ', res)
      if (res.length > 0) {
        this.selectedManager = res[0]
        // console.log('res ', res[0])
      }
      // this.selectedManager.UNP = this.contragents.filter(mng => this.selectedManager.FiszLico === mng.Kontragent)[0].UNP
      // console.log('this.selectedManager.UNP ', this.contragents.filter(mng => this.selectedManager.FiszLico === mng.Kontragent)[0].UNP)
      // this.getManagerSalesByYear(this.selectedManager)
    },
    // Вызывается из Login
    async firstLogin () {
      console.log('auth')
      this.loginContragent()
    },
    showLogin () {
      console.log('SHOW LOGIN')
      this.showLoginModal = true
    },
    logoff () {
      console.log('logoff')
      this.authorized = false
      this.mng = false
      this.ai = 0
      // location.reload()
    },
    async loginContragent () {
      console.log('loginContragent')
      this.Login = this.Login.trim()
      this.Password = this.Password.trim()
      console.log('login ', this.Login)
      console.log('passw ', this.Password)
      if (this.Login === '') return -1
      this.countDown()
      var res = []
      let response = await ApiService.auth(this.Login, this.Password)
      // console.log(JSON.stringify(response))
      // console.log('response.data.Manager ', response.data)
      // if (response.data.Ответ === 'Successful !' && (Number(this.Login) < 100 || this.Login === '100511773')) this.mng = true
      // if (response.data.Ответ === 'Successful !' && (response.data.Manager === true || this.Login === '100511773')) this.mng = true

      if (response.data.Ответ === 'Successful !') {
        // if (this.mng === false) {
        console.log('Client login')

        // res = this.contragents.filter(contragent => contragent.UNP.trim() === this.Login)
        res = response.data.Kontragent
        // console.log('Contragent from response:', res)
        if (res.length === 1) {
          this.selectedContragent = res[0]
          this.selectedContragent.priceCurrency = ''
          console.log('Selected Contragent from response:', JSON.stringify(this.selectedContragent))
          if (this.selectedContragent.Manager !== false) {
            this.mng = true
            res = this.managers.filter(manager => manager.FiszLico === this.selectedContragent.Manager)
            if (res.length > 0) {
              this.activeMng = res[0]
              this.selectedManager = this.activeMng
            }
          }
          await this.getBonus()
        } else {
          res = await this.contragents.filter(contragent => contragent.UNP === this.Login)
          if (res.length === 1) {
            this.selectedContragent = res[0]
            this.selectedContragent.priceCurrency = ''
            console.log('Selected Contragent from file (duplicated UNP):', JSON.stringify(this.selectedContragent))
          }
        }
        // BOSS ENTRY
        if (this.Login === '0000000055' || this.Login === '000000100') {
          res = this.contragents.filter(contragent => contragent.UNP.trim() === '100511773')
          this.selectedContragent = res[0]
          this.mng = true
          this.boss = true
          /*
          res = this.managers.filter(manager => manager.FiszLico === 'ВСЕ')
          if (res.length > 0) {
            this.activeMng = res[0]
            this.selectedManager = this.activeMng
          }
          */
        }
        if (this.Login === '000000053' || this.Login === '000000054' || this.Login === '0000000055') {
          console.log('special Prices')
          this.getGoodsInfotron()
          this.getInfotronicOrderList()
        }
        if (this.selectedContragentBalance > 0) {
          this.getContragentInvoices()
        }
        if (this.mng) {
          // res = response.data.Kontragent
          // res = await this.contragents.filter(contragent => contragent.UNP === '100511773')
          await this.getBonus()
          var storedContragent = this.$localStorage.get('selectedContragent')

          if (storedContragent !== null) {
            console.log('storedContragent:' + storedContragent)
            res = await this.contragents.filter(contragent => contragent.UNP === storedContragent.toString())
          }
          if (storedContragent === null) {
            console.log('No stored Contragent:')
            res = await this.contragents.filter(contragent => contragent.UNP === this.selectedContragent.UNP)
          }

          // console.log('res:' + JSON.stringify(res))

          if (res.length > 0) {
            this.selectedContragent = res[0]
            this.selectedContragent.priceCurrency = ''
          } else {
            var res10 = await this.contragents.filter(contragent => contragent.OsnmanagerCode === this.activeMng.ManagerCode)
            if (res10.length === 1) {
              this.selectedContragent = res10[0]
              this.selectedContragent.priceCurrency = ''
            }
          }
        }
      }

      console.log('Active:' + this.selectedContragent.Aktivenb2b)
      if (response.data.Ответ === 'Successful !' && this.selectedContragent !== '') {
        this.getOrderList()
        this.user = {}
        this.user.mng = this.mng
        this.user.Login = this.Login
        this.getPrices()
        console.log(this.selectedContragent.Kontragent)
        this.authorized = true
        this.showLoginModal = false
        this.hidebasket = false
        if (this.rememberMe) {
          this.$localStorage.set('Login', this.Login)
          this.$localStorage.set('Password', this.Password)
        }
        var res1 = this.managers.filter(manager => manager.ManagerCode === this.selectedContragent.OsnmanagerCode)
        if (res1.length === 1) { this.selectedContragentManager = res1[0] }
        // console.log('this.selectedContragentManager')
        var res2 = this.balance.filter(contragent => contragent.UNP === this.selectedContragent.UNP)
        if (res2.length === 1) { this.selectedContragentBalance = res2[0].Summa }
        const response4 = await ApiService.getStockFile()
        this.stock = response4.data

        await this.copyPrices()

        if (this.selectedContragentBalance > 0) {
          this.getContragentInvoices()
        }
        await this.getClientBasket(this.selectedContragent.UNP)
        await this.getFavs()
        return true
      } else {
        // console.log(this.Login, ' ', JSON.stringify(response))
        await ApiService.writeErrorLog(JSON.stringify(response))
        this.showLoginModal = true
        if (response.status === 200) {
          this.$localStorage.remove('Login')
          this.$localStorage.remove('Password')
          this.$dialog.alert('Неверное сочетание Логин-Пароль').then(function (dialog) {
            console.log(response.data)
          })
        } else {
          this.$dialog.alert('Сервис авторизации временно недоступен, попробуйте зайти позже').then(function (dialog) {
            console.log(response.data)
          })
        }
        return false
      }
    },
    async getClientBasket (UNP) {
      this.selectedContragentBasket = []
      try {
        console.log('Получаем файл корзины с сайта по УНП:' + UNP)
        const res3 = await ApiService.getOrderFile(UNP)
        if (res3.data !== null) {
          this.selectedContragentBasket = res3.data
          console.log('Get order from file success')
          this.selectedContragentBasket.forEach((orderitem) => {
            const res4 = this.goods.filter((good) => good.NomCode === orderitem.NomCode)
            if (res4.length > 0) {
              res4[0].Quantity = orderitem.Quantity
              res4[0].Price = orderitem.Price
            }
          })
        } else {
          console.log('Файл корзины пустой')
          this.selectedContragentBasket = []
        }
      } catch (error) {
        console.error('Error loading client basket:', error)
      }
    },
    async loginMng (UID) {
      this.showLoginModal = false
      console.log('loginMng')
    },
    async checkip () {
      // axios.get('https://ipinfo.io/json').then(response => (this.info.IP = response.data)).catch(error => console.log(error))
      // this.info.MNG = this.$localStorage.get('MNG')
      // this.info.DescriptionMNG = this.$localStorage.get('DescriptionMNG')
    },
    // Проверка на сервере
    async checkauth () {
      console.log('checkauth')
      // await this.checkip()
      /*
      await this.$getLocation({
        enableHighAccuracy: true, // defaults to false
        timeout: Infinity, // defaults to Infinity
        maximumAge: 0 // defaults to 0
      })
        .then(coordinates => {
          this.coordinates = coordinates
          // console.info('lat:' + coordinates.lat + ' ' + coordinates.lng)
        })
        await axios.get('https://www.mapquestapi.com/geocoding/v1/reverse?key=WA0p3YA8OJqJn6PmJcduG19GkqlRYDgm&location=' + this.coordinates.lat + '%2C' + this.coordinates.lng + '&outFormat=json&thumbMaps=false').then(response => (this.info = response.data)).catch(error => console.log(error))
      console.info(this.info.results[0].locations[0].adminArea5 + ',' + this.info.results[0].locations[0].street)

      // await ApiService.auth(UID, this.info.results[0].locations[0].adminArea5 + ',' + this.info.results[0].locations[0].street)
      var uid = this.$localStorage.get('UID', 'false')
      var mng = this.$localStorage.get('MNG', 'false')
      if (uid === 'false' && mng === 'false') {
        ApiService.auth('1224b3a5-e75e-11e5-a13e-00e04d95380f', 'РОЗНИЧНЫЙ КЛИЕНТ ')
        console.log('both false')
        return false
      }
      if (mng !== 'false' && uid !== 'false') {
        // await this.checkip()
        // var info = JSON.stringify(this.info)
        // console.log(info)
        let response = await ApiService.authMNG(mng, this.info)
        // console.log(response)
        if (response.data !== 'Auth ERROR') {
          if (response.data.value[0]['Ref_Key'] === mng) {
            console.log('mng true')
            this.selectedManager = mng
            // this.getManagerSalesByYear(this.selectedManager)
            if (mng === 'e64c5b0c-ea8e-11e5-989f-001bfc6da658') {
              this.mngsq = true
              this.selectedContragent = 'a3fb6535-0c77-11e6-8933-e41f13c4e72c'
              // this.selectContragent()
              console.log('MNG SQ')
              console.log(this.selectedContragent)
            }
            this.mngProcedures()
          }
        }
      }
      if (uid !== 'false') {
        let response = await ApiService.auth(uid, this.info)
        // console.log(response.data)
        if (response.data !== 'Auth ERROR') {
          if (response.data.value[0]['Контрагент_Key'] === uid) {
            console.log('user true')
            let data = response.data
            this.user = data.value[0]
            this.authorized = true
            // this.showModal = false
            this.authorization(this.user)
            // this.$emit('auth', this.user)
          }
        }
      }
      */
    },
    // Процедуры при загрузке клиента
    async authorization (event) {
      console.log('authorization')
    },
    async getFolders () {
      console.log('folders')
      // const response = await ApiService.getFolders()
      // let data = response.data
      // this.folders = data.value
    },
    /*
    async getManagers () {
      console.log('managers')
      const response = await ApiService.managers()
      let data = response.data
      this.managers = data.value
      console.log(this.managers)
      this.managers.sort((a, b) => {
        let fa = a.FiszLico.toLowerCase()
        let fb = b.FiszLico.toLowerCase()
        if (fa < fb) {
          return -1
        }
        if (fa > fb) {
          return 1
        }
        return 0
      })
    },
    */
    changeFav (event) {
      console.log('changeFav event:', event)
      this.favkey = event
    },
    getPrice (goodCode) {
      var res = this.prices.filter(price => (price.NomCode === goodCode))
      if (res.length !== 1) return 0
      return parseFloat(res[0].Cena.replaceAll(',', '.'))
    },
    async copyPrices () {
      console.log('CopyPrices START:' + Math.floor(Date.now() / 1000))
      this.loading = true
      var pictures = await ApiService.getPictureList()

      this.goods.forEach((good) => {
        good.NomNaim = good.NomNaim.replace('НР', 'HP')
        good.NomNaim = good.NomNaim.replace('СF', 'CF')
        good.NomNaim = good.NomNaim.replace('/^НР$/', 'HP')
        good.NomNaim = good.NomNaim.replace('СЕТ', 'CET')
        good.NomNaim = good.NomNaim.replace('КМ', 'KM')
        good.NomNaim = good.NomNaim.replace('НВ', 'HB')
        good.NomNaim = good.NomNaim.replace(/\//g, ' ')
        const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1)
        good.NomNaim = capitalize(good.NomNaim)
        good.Quantity = ''
        // good.Price = this.getPrice(good.NomCode)
        var pic = pictures.data.filter(item => (item === good.NomCode))
        if (pic.length > 0) {
          good.hasPicture = true
          // console.log(good.NomCode)
        } else good.hasPicture = false

        var goodstocks = this.stock.filter(item => (item.NomCode === good.NomCode))

        // console.log(prices)
        if (goodstocks !== undefined) {
          goodstocks.forEach((st) => {
            // console.log(JSON.stringify(st))
            if (st.Sklad === '000000014') {
              good.skladBelka = st.quantity * 1
              if (isNaN(st.Rezerv)) good.skladBelkaRezerv = 0
              else { good.skladBelkaRezerv = st.Rezerv * 1 }
            }
            if (st.Sklad === '000000006') {
              good.skladMain = st.quantity * 1
              if (isNaN(st.Rezerv)) good.skladMainRezerv = 0
              else { good.skladMainRezerv = st.Rezerv * 1 }
            }
            if (st.Sklad === '000000055') {
              good.skladBrest = st.quantity * 1
              if (isNaN(st.Rezerv)) good.skladBrestRezerv = 0
              else { good.skladBrestRezerv = st.Rezerv * 1 }
            }
            if (st.Sklad === '000000031') {
              good.skladGomel = st.quantity * 1
              if (isNaN(st.Rezerv)) good.skladGomelRezerv = 0
              else { good.skladGomelRezerv = st.Rezerv * 1 }
            }
            if (st.Sklad === '000000052') {
              good.skladGrodno = st.quantity * 1
              if (isNaN(st.Rezerv)) good.skladGrodnoRezerv = 0
              else { good.skladGrodnoRezerv = st.Rezerv * 1 }
            }
            if (st.Sklad === '000000065') {
              good.skladMogilev = st.quantity * 1
              if (isNaN(st.Rezerv)) good.skladMogilevRezerv = 0
              else { good.skladMogilevRezerv = st.Rezerv * 1 }
            }
            if (st.Sklad === '000000263') {
              good.skladMoskva = st.quantity * 1
              if (isNaN(st.Rezerv)) good.skladMoskvaRezerv = 0
              else { good.skladMoskvaRezerv = st.Rezerv * 1 }
            }

            /*

    skladFasovka (goodCode) {
      if (this.stock !== null) var res = this.stock.filter(stock => (stock.NomCode === goodCode && stock.Sklad === '000000029'))
      if (res.length === 0) return 0
      return res[0].quantity * 1
    },

          */
          })
        }
        good.fav = false
      })
      this.stock.splice(0, this.stock.length)
      console.log('CopyPrices END:', Math.floor(Date.now() / 1000))
      await this.getFavs()
      this.loading = false
    },

    async getFavs () {
      try {
        var oldfavs = this.goods.filter((good) => good.fav === true)
        oldfavs.forEach((good) => {
          good.fav = false
        })
        this.selectedContragentFav = []
        const res = await ApiService.getFavFile(this.selectedContragent.UNP)
        //     console.log(res)
        if (res.data !== null && res.status === 200) {
          this.selectedContragentFav = res.data
          console.log('Get favs from file success')

          this.selectedContragentFav.forEach((favitem) => {
            const res1 = this.goods.filter((good) => good.NomCode === favitem.NomCode)
            if (res1.length > 0) {
              //           console.log(res1[0].NomCode, ' ', res1[0].fav)
              res1[0].fav = true
            }
          })
        }
      } catch (error) {
        console.error('Error loading favs:', error)
      }
    },
    async getGoodsInfotron () {
      // this.loading = true
      this.goodsInfotronic.splice(0, this.goodsInfotronic.length)
      // this.getFolders()
      const response = await ApiService.getInfotronicData()
      let data = response.data
      // console.log(data)
      if (this.goodsInfotronic !== undefined) {
        this.goodsInfotronic = data
        this.goods.forEach((good) => {
          var selectedGood = this.goodsInfotronic.filter(goodInf => goodInf.Code === good.NomCode)
          if (selectedGood.length === 1) good.Articul = selectedGood[0].Articul
        })
        this.goodsInfotronic1C.splice(0, this.goodsInfotronic1C.length)
        const response1 = await ApiService.getInfotronic1C()
        let data1 = response1.data.value
        this.goodsInfotronic1C = data1
      }
    },
    async getPartnerABCXYZ (partnerKey) {
      this.partnerABCXYZ = []
      console.log('PartnerABCXYZ - length ' + this.partnersABCXYZ.length)
      this.partnerABCXYZ = this.partnersABCXYZ.filter(partner => partner.Партнер_Key === partnerKey)
      // console.log(this.partnerABCXYZ)
    },
    async getPartnersSalesPeriodShort () {
      console.log('PartnersSalesPeriodShort')
      for (var i = 0; i < 12; i++) {
        // var startDate = format(subDays(Date(), 7 * i - 1 + 7), 'YYYY-MM-DD')
        // var endDate = format(subDays(Date(), 7 * i - 1), 'YYYY-MM-DD')
        var startDate = format(subMonths(Date(), i + 1), 'YYYY-MM-DD')
        var endDate = format(subMonths(Date(), i), 'YYYY-MM-DD')
        // console.log(startDate + ' ' + endDate)
        const response = await ApiService.partnersSalesByPeriodShort(startDate, endDate)
        // console.log(response)
        let data = response.data
        this.partnersSalesByPeriodShort[i] = []
        this.partnersSalesByPeriodShort[i] = data.value
      }
    },
    async addPartnerSalesShort () {

    },
    async getPartnersABCXYZ () {

    },
    async getClientBalance () {
    },
    escCloseModal (e) {
      // console.log('pressed ' + e.key)
      if (e.key === 'Escape') {
        // console.log('pressed ' + e.key)
        this.showOrderModal = false
        this.showModalOrders = false
        if (!this.showModalGlobalSearch) this.showModalSpecialOrders = false
        this.showModalOrdersInfotronic = false
        this.showBonusModal = false
        this.showModalGlobalSearch = false
      }
    },

    async getBusinessRegions () {
      console.log('BusinessRegions')
      let response = await ApiService.getBusinessRegions()
      this.businessRegions = response.data.value
    },
    businessregion (region) {
      var reg = ''
      var result = this.businessRegions.filter(br => br.Ref_Key === region)
      if (result.length > 0) {
        // console.log(result[0].Description)
        reg = result[0].Description
        if (result[0].Description !== '00000000-0000-0000-0000-000000000000') {
          result = this.businessRegions.filter(br => br.Ref_Key === result[0].Parent_Key)
          if (result.length > 0) {
            reg += ', ' + result[0].Description
            if (result[0].Description !== '00000000-0000-0000-0000-000000000000') {
              result = this.businessRegions.filter(br => br.Ref_Key === result[0].Parent_Key)
              if (result.length > 0) {
                reg += ', ' + result[0].Description
              }
            }
          }
        }
      }
      return reg
    },
    async getInfotronicOrderList () {
      this.ordersInfotronic = []
      let response = await ApiService.getInfotronicOrders()
      // console.log(response)
      if (response.data !== undefined) {
        this.ordersInfotronic = response.data.value
        // console.log('Infotronic Orders found:' + this.ordersInfotronic.length)
      }
    },
    async getOrderList () {
      this.orders = []
      let response = await ApiService.getOrdersStatus(this.selectedContragent.UNP)
      if (response.data !== undefined) {
        this.orders = response.data
        console.log('Orders found:' + this.orders.length)
      }
    },
    async getSpecialOrderList () {
      console.log('getSpecialOrderList ' + Math.floor(Date.now() / 1000))
      this.specialOrders = []
      this.specialOrdersManager = []

      let response1 = await this.getSpecialOrderFileManager(this.Login)

      if (response1.data !== null) {
        this.specialOrdersManager = response1.data
        let response = await ApiService.readSpecialOrderFile(this.Login)

        if (response.data !== null) {
          this.specialOrders = response.data
          // this.specialOrders.sort((a, b) => this.formatDate1(a.date) - this.formatDate1(b.date))
          // console.log('Special Orders:' + JSON.stringify(this.specialOrders))
        }
      }
      // this.specialOrdersSync = []
      if (this.specialOrdersManager !== undefined) {
        this.specialOrders.forEach(order => {
          var orderMng = this.specialOrdersManager.filter(mng => mng.guid === order.guid)
          if (orderMng.length > 0) {
            // const date = new Date(order.date)
            // const dateMng = new Date(orderMng[0].date)
            // if (parseInt(order.status) === 8 && parseInt(orderMng[0].status) === 8) this.specialOrdersSync.push(order.guid)
            // if (dateMng >= date) {
            if (orderMng[0].status > order.status) {
              order.status = parseInt(orderMng[0].status)
            }
            order.date = orderMng[0].date
            order.price = orderMng[0].price
            order.response = orderMng[0].response
            order.term = orderMng[0].term
            order.supplier = parseInt(orderMng[0].supplier)
            order.ordernumber = orderMng[0].ordernumber
            order.number = orderMng[0].number
          //  }
          }
        })
        let guidsArray1 = this.specialOrders.map(item => item.guid)
        let filteredArray2 = this.specialOrdersManager.filter(item => !guidsArray1.includes(item.guid))
        if (filteredArray2.length > 0) {
          filteredArray2.forEach(item => {
            this.specialOrders.push(item)
          })
        }

        // this.specialOrders = this.specialOrders.filter(order => parseInt(order.status) !== 8)
        /*
        var orderfilesync = JSON.stringify(this.specialOrdersSync)
        console.log(orderfilesync)
        var ressync = await ApiService.writeSpecialOrderSyncFile(this.Login, orderfilesync)
        console.log(ressync.status)

        this.specialOrders = this.specialOrders.filter(order => {
          return !this.specialOrdersSync.some(syncOrder => syncOrder === order.guid)
        })
        this.specialOrdersManager = this.specialOrdersManager.filter(order => {
          return !this.specialOrdersSync.some(syncOrder => syncOrder === order.guid)
        })
        */
        this.specialOrders.forEach(order => {
          if (!order.hasOwnProperty('ClientUNP')) {
            order.ClientUNP = '' // Здесь вы можете установить любое значение для поля ClientUNP
          }
          order.type = parseInt(order.type)
          order.sklad = parseInt(order.sklad)
          order.status = parseInt(order.status)
          order.supplier = parseInt(order.supplier)
        })
        var orderfile = JSON.stringify(this.specialOrders)
        // console.log(orderfile)
        var res = await ApiService.writeSpecialOrderFile(this.Login, orderfile)
        console.log(res.status)
      }
      //  let nonUniqueValues = this.findNonUniqueValues(this.specialOrders, 'number', 'UNP')
      //  console.log(nonUniqueValues)
    },
    async getSpecialOrdersList () {
      let response = await ApiService.getSpecialOrdersList()

      if (response.data !== null) {
        this.specialOrdersFiles = response.data
        console.log('Special Orders files found:' + this.specialOrdersFiles + ' ' + Math.floor(Date.now() / 1000))
      }
    },
    async getSpecialOrdersListGlobal () {
      console.log('getSpecialOrdersListManager' + Math.floor(Date.now() / 1000))
      try {
        const specialOrders = []
        this.specialOrdersGlobal = []
        const response = await ApiService.getSpecialOrdersListManager()
        if (response.data) {
          const promises = response.data.map(specialOrder => this.getSpecialOrderFileManager(specialOrder.replace(/\.[^/.]+$/, '')))
          const results = await Promise.all(promises)
          if (results && results.length > 0) {
          // var res = results.data
          // console.log(JSON.stringify(results))
            results.forEach(res => {
              // console.log(JSON.stringify(result))
              if (res && res.data) {
                res.data.forEach(result => {
                  const newSpecialOrder = {
                    number: result.number,
                    date: result.date,
                    manager: result.manager,
                    client: result.client,
                    UNP: result.UNP,
                    guid: result.guid,
                    good: result.good,
                    quantity: result.quantity,
                    price: result.price,
                    response: result.response,
                    term: result.term,
                    type: result.type,
                    supplier: result.supplier,
                    status: result.status,
                    version: result.version,
                    ordernumber: result.ordernumber
                  }
                  specialOrders.push(newSpecialOrder)
                })
              }
            })
            // console.log('Final specialOrders Managers:', specialOrders)
            this.specialOrdersGlobal = specialOrders
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getSpecialOrdersListManager () {
      console.log('getSpecialOrdersListManager' + Math.floor(Date.now() / 1000))
      try {
        // const response = await ApiService.getSpecialOrdersListManager()
        var specialOrders = {}

        specialOrders = await this.getSpecialOrderFileManager(this.Login)

        console.log('Final specialOrderManagers:', specialOrders.data)
        this.specialOrdersManager = specialOrders.data
        // this.specialOrders.sort((a, b) => this.formatDate1(a.date) - this.formatDate1(b.date))
      } catch (error) {
        console.error(error)
      }
    },
    async getSpecialOrderFileManager (UNP) {
      console.log('getSpecialOrderFileManager:' + Math.floor(Date.now() / 1000))
      return new Promise(async (resolve, reject) => {
        try {
          const data = await ApiService.readSpecialOrderFileManager(UNP)
          resolve(data) // В случае успешного выполнения возвращаем данные
        } catch (error) {
          alert(error)
          reject(error) // В случае ошибки возвращаем ошибку
        }
      })
    },
    async createOrder () {
      console.log('create order')
      var uid = this.$localStorage.get('UID', 'false')
      await ApiService.createOrder(this.user.Партнер_Key, this.user.Контрагент_Key, this.user.Ref_Key)
      this.getOrderList(uid)
      this.activeOrder = this.orders.length - 1
    },
    async getPartnersSalesByYear () {
      console.log('PartnersSalesByYear')
      var date = new Date()
      var year = date.getFullYear().toString()
      const response0 = await ApiService.partnersSalesByYear(year)
      const response1 = await ApiService.partnersSalesByYear((year - 1))
      const response2 = await ApiService.partnersSalesByYear((year - 2))
      this.partnersSales[0] = response0.data
      this.partnersSales[1] = response1.data
      this.partnersSales[2] = response2.data
    },
    async getManagersSalesByYear () {
      console.log('ManagersSalesByYear')
      var date = new Date()
      var year = date.getFullYear().toString()
      const response0 = await ApiService.managersSalesByYear(year)
      const response1 = await ApiService.managersSalesByYear((year - 1))
      const response2 = await ApiService.managersSalesByYear((year - 2))
      this.managersSales[0] = response0.data
      this.managersSales[1] = response1.data
      this.managersSales[2] = response2.data
    },
    getPartnerSalesByYear (partnerAnalyticsKey) {
      console.log('PartnerSalesByYear')
      var date = new Date()
      var month = date.getMonth()
      this.partnerSales[0] = []
      this.partnerSales[1] = []
      this.partnerSales[2] = []
      for (var i = 1; i <= month + 1; i++) {
        if (this.partnersSales[0][i][partnerAnalyticsKey] !== undefined) {
          this.partnerSales[0][i - 1] = this.partnersSales[0][i][partnerAnalyticsKey]
        } else this.partnerSales[0][i - 1] = 0
      }
      for (i = 1; i < 13; i++) {
        if (this.partnersSales[1][i][partnerAnalyticsKey] !== undefined) {
          this.partnerSales[1][i - 1] = this.partnersSales[1][i][partnerAnalyticsKey]
        } else this.partnerSales[1][i - 1] = 0
        if (this.partnersSales[2][i] !== undefined && this.partnersSales[2][i][partnerAnalyticsKey] !== undefined) {
          this.partnerSales[2][i - 1] = this.partnersSales[2][i][partnerAnalyticsKey]
        } else this.partnerSales[2][i - 1] = 0
      }
      var total0 = 0
      var total1 = 0
      var total2 = 0
      // console.log(month)
      this.partnerSalesTotal[0] = []
      this.partnerSalesTotal[1] = []
      this.partnerSalesTotal[2] = []
      for (i = 0; i < 12; i++) {
        this.partnerSalesTotal[0][i] = 0
        this.partnerSalesTotal[1][i] = 0
        this.partnerSalesTotal[2][i] = 0
      }
      for (i = 0; i <= month; i++) {
        total0 += Math.round(this.partnerSales[0][i])
        // total1 += Math.round(this.partnerSales[1][i])
        // total2 += Math.round(this.partnerSales[2][i])
        this.partnerSalesTotal[0][i] = total0
        // this.partnerSalesTotal[1][i] = total1
        // this.partnerSalesTotal[2][i] = total2
      }
      for (i = 0; i < 12; i++) {
        // total0 += Math.round(this.partnerSales[0][i])
        total1 += Math.round(this.partnerSales[1][i])
        total2 += Math.round(this.partnerSales[2][i])
        // this.partnerSalesTotal[0][i] = total0
        this.partnerSalesTotal[1][i] = total1
        this.partnerSalesTotal[2][i] = total2
      }
    },
    jsonEscape (str) {
      return str.replace(/\n/g, '\\\\n').replace(/\r/g, '\\\\r').replace(/\t/g, '\\\\t')
    },
    async addSpecialOrder () {
      await this.getSpecialOrderList()
      var manager = this.activeMng.ManagerCode
      console.log(manager)
      this.specialOrders.unshift({
        number: '', // this.maxnumber + 1,
        version: 0,
        guid: this.generateGuid(),
        date: this.formatDate1(new Date()),
        manager: manager,
        client: this.selectedContragent.Kontragent,
        СlientUNP: '',
        UNP: this.Login,
        good: '',
        quantity: '',
        price: '',
        response: '',
        term: '',
        sklad: 0,
        type: 1,
        supplier: 0,
        status: 1,
        ordernumber: ''
      })
    },
    generateGuid () {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
    },
    getManagerSalesByYear (ManagerKey) {
      var date = new Date()
      var month = date.getMonth()
      this.managerSales[0] = []
      this.managerSales[1] = []
      this.managerSales[2] = []
      var total0 = 0
      var total1 = 0
      var total2 = 0
      // console.log(month)
      this.managerSalesTotal[0] = []
      this.managerSalesTotal[1] = []
      this.managerSalesTotal[2] = []
      for (var i = 0; i < 12; i++) {
        this.managerSalesTotal[0][i] = 0
        this.managerSalesTotal[1][i] = 0
        this.managerSalesTotal[2][i] = 0
      }
      if (ManagerKey !== '00000000-0000-0000-0000-000000000000') {
        console.log('ManagerSalesByYear')
        for (i = 1; i <= month + 1; i++) {
          if (this.managersSales[0][i][ManagerKey] !== undefined) {
            this.managerSales[0][i - 1] = this.managersSales[0][i][ManagerKey]
          } else this.managerSales[0][i - 1] = 0
        }
        for (i = 1; i < 13; i++) {
          if (this.managersSales[1][i][ManagerKey] !== undefined) {
            this.managerSales[1][i - 1] = this.managersSales[1][i][ManagerKey]
          } else this.managerSales[1][i - 1] = 0
          if (this.managersSales[2][i] !== undefined && this.managersSales[2][i][ManagerKey] !== undefined) {
            this.managerSales[2][i - 1] = this.managersSales[2][i][ManagerKey]
          } else this.managerSales[2][i - 1] = 0
        }
        for (i = 0; i <= month; i++) {
          total0 += Math.round(this.managerSales[0][i])
          this.managerSalesTotal[0][i] = total0
        }
        for (i = 0; i < 12; i++) {
          total1 += Math.round(this.managerSales[1][i])
          total2 += Math.round(this.managerSales[2][i])
          this.managerSalesTotal[1][i] = total1
          this.managerSalesTotal[2][i] = total2
        }
      } else {
        console.log('TotalSalesByYear')
        var sum = 0.0
        for (i = 1; i <= month + 1; i++) {
          sum = 0.0
          for (var key in this.managersSales[0][i]) {
            // console.log(this.managersSales[0][i][key])
            sum += Number(this.managersSales[0][i][key])
            // console.log(' sum:' + sum)
          }
          this.managerSales[0][i - 1] = sum
          // console.log(this.managerSales[0][i - 1])
          // this.managerSales[0][i - 1] = this.managersSales[0][i][ManagerKey]
        }
        for (i = 1; i < 13; i++) {
          sum = 0.0
          for (key in this.managersSales[1][i]) {
            sum += this.managersSales[1][i][key]
          }
          this.managerSales[1][i - 1] = sum
          sum = 0.0
          for (key in this.managersSales[2][i]) {
            sum += this.managersSales[2][i][key]
          }
          this.managerSales[2][i - 1] = sum
        }
        for (i = 0; i <= month; i++) {
          total0 += Math.round(this.managerSales[0][i])
          this.managerSalesTotal[0][i] = total0
        }
        for (i = 0; i < 12; i++) {
          total1 += Math.round(this.managerSales[1][i])
          total2 += Math.round(this.managerSales[2][i])
          this.managerSalesTotal[1][i] = total1
          this.managerSalesTotal[2][i] = total2
        }
      }
    },
    async getPartnersSalesByYearByGoods () {
      console.log('PartnersSalesByYearByGoods')
      var date = new Date()
      var year = date.getFullYear().toString()
      const response0 = await ApiService.partnersSalesByYearByGoods(year)
      const response1 = await ApiService.partnersSalesByYearByGoods((year - 1))
      const response2 = await ApiService.partnersSalesByYearByGoods((year - 2))
      this.partnersSalesByGoods[0] = response0.data
      this.partnersSalesByGoods[1] = response1.data
      this.partnersSalesByGoods[2] = response2.data
    },
    emptyBasket () {
      console.log('empty basket')
      this.goods.forEach((good) => {
        good.Quantity = ''
      })
      this.selectedContragentBasket = []
    },
    async addGood (good) {
      //  console.log('addGood ' + good.NomCode)
      //  console.log('addGood ' + good.Quantity)
      //  console.log('addGood ' + good.Price)
      var itemfound = this.goods.filter(basketgood => (basketgood.NomCode === good.NomCode))
      if (itemfound.length === 1) { itemfound[0].Quantity = good.Quantity }
      // console.log('itemfound ' + itemfound.length)
      if (good.Quantity !== '' && itemfound.length !== 1) { await this.getClientBasket(this.selectedContragent.UNP) }
      this.selectedContragentBasket = this.goods.filter(basketgood => (basketgood.Quantity > 0))
      var order = JSON.stringify(this.selectedContragentBasket)
      // console.log('order ' + order)
      var res = await ApiService.putOrderFile(this.selectedContragent.UNP, order)
      // var goodstr = JSON.stringify(res)
      console.log('addGood ' + res.status)
    }
  },
  async beforeMount () {
  },
  destroyed () {
    // window.removeEventListener('keydown', this.escCloseModal)
  },
  async mounted () {
    console.log('App Mounted')
    console.log(this.$route.name)
    if (this.$route.path !== '/Quiz') {
      const response3 = await ApiService.getContragentsFile()
      this.contragents = response3.data
      console.log('contragents')
      this.contragents.sort((a, b) => {
        let fa = a.Kontragent.toLowerCase()
        let fb = b.Kontragent.toLowerCase()
        if (fa < fb) {
          return -1
        }
        if (fa > fb) {
          return 1
        }
        return 0
      })
      this.contragents.forEach((contragent) => {
        contragent.UNP = contragent.UNP.trim()
        if (contragent.Tip === 4 || contragent.Tip === 6 || contragent.Gorod === 'rf') contragent.priceCurrency = 'RUB'
        else contragent.priceCurrency = 'BYN'
      })

      this.startDate = subDays(Date(), 7)
      this.endDate = addDays(Date(), 0)
      this.dateOne = this.startDate
      this.dateTwo = this.endDate
      this.dateone = this.startDate
      this.datetwo = this.endDate
      console.log('mounted date', this.startDate, ' ', this.endDate)
      // const response = ApiService.getProducts()
      // this.activeItem = this.$route.matched[0].props.default.page
      const response5 = await ApiService.getBalanceFile()
      this.balance = response5.data
      console.log('balance')
      const response6 = await ApiService.getCurrencyRates()
      this.currencyRates = response6.data
      console.log('CurrencyRates')
      const response4 = await ApiService.getStockFile()
      this.stock = await response4.data
      console.log('stock')

      if (this.stock === null) {
        console.log('STOCK file is BUSY')
      }

      const response2 = await ApiService.getManagersFile()
      this.managers = await response2.data
      console.log('managers')
      const table = {}
      this.managers = this.managers.filter(({ ManagerCode }) => (!table[ManagerCode] && (table[ManagerCode] = 1)))
      this.managers.sort((a, b) => {
        let fa = a.ManagerCode.toLowerCase()
        let fb = b.ManagerCode.toLowerCase()
        if (fa < fb) {
          return -1
        }
        if (fa > fb) {
          return 1
        }
        return 0
      })
      this.managers.unshift({
        EMail: 'ВСЕ',
        FiszLico: 'ВСЕ',
        ManagerCode: 'ВСЕ',
        ManagerTel: '',
        TelVnutr: '',
        Telephones: '+375173880765, +375291554400, +375297554554'
      })
      const response1 = await ApiService.getPricesFile()
      this.prices = await response1.data
      console.log('Get prices')
      // json = json.replace(/\n/g, '\\\n')
      // this.prices = JSON.parse(json)
      // this.prices = JSON.parse(json)
      // console.log(this.prices)
      // await new Promise(resolve => setTimeout(resolve, 1000))
      const response = await ApiService.getProductsFile()
      let data = await response.data
      console.log('goods')
      this.goods = data.filter(good => good.IsGropup !== 'Да')
      /*
      this.goods.sort((a, b) => {
        let fa = a.NomNaim.toLowerCase()
        let fb = b.NomNaim.toLowerCase()
        if (fa < fb) {
          return -1
        }
        if (fa > fb) {
          return 1
        }
        return 0
      })
  */
      this.folders = data.filter(good => good.IsGropup === 'Да')
      this.folders.sort((a, b) => {
        let fa = a.NomNaim.toLowerCase()
        let fb = b.NomNaim.toLowerCase()
        if (fa < fb) {
          return -1
        }
        if (fa > fb) {
          return 1
        }
        return 0
      })
      if (this.$localStorage.get('Login') !== null && this.$localStorage.get('Password') !== null) {
        this.Login = this.$localStorage.get('Login')
        this.Password = this.$localStorage.get('Password')
        this.loginContragent()
        console.log(this.Login)
        console.log(this.Password)
        // this.showLoginModal = false
      } else this.showLoginModal = true

      if (this.$route.name === 'Catalog') this.ai = 1
      else if (this.$route.name === 'Information') this.ai = 4
      else this.ai = 0
      this.favkey = Math.random()
      window.addEventListener('showLogin', this.showLogin)
      window.addEventListener('logoff', this.logoff)
      window.addEventListener('keyup', this.escCloseModal)
      window.addEventListener('emptyBasket', this.emptyBasket)
      this.selectedManager = this.managers.filter(mng => mng.ManagerCode === this.activeMng.ManagerCode)
    }
  },
  computed: {
    filteredListSpecialOrders () {
      var filteredArray = this.specialOrders.filter(order => {
        var keywords = this.search.split(' ')
        var res = true
        if (parseInt(this.specialOrdersSupplier) !== parseInt('0') && parseInt(order.supplier) !== parseInt(this.specialOrdersSupplier)) res = false
        if (parseInt(this.specialOrdersStatus) !== parseInt('0') && parseInt(order.status) !== parseInt(this.specialOrdersStatus)) res = false
        //  if (parseInt(order.status) === 8) res = false
        if (parseInt(this.specialOrdersType) !== parseInt('0') && parseInt(order.type) !== parseInt(this.specialOrdersType)) res = false
        if (format(order.date, 'YYYY-MM-DD') < format(this.startDate, 'YYYY-MM-DD') || format(order.date, 'YYYY-MM-DD') > format(this.endDate, 'YYYY-MM-DD')) {
          // console.log('false ')
          res = false
        }

        // console.log('this.specialOrdersStatus ', this.specialOrdersStatus)
        keywords.forEach((element, index) => {
          var str = order.UNP + ' ' + order.client + ' ' + order.manager + ' ' + order.good + ' ' + order.response + ' ' + order.number + '-' + order.version
          var res1 = str.toString().toLowerCase().includes(element.toString().toLowerCase())
          if (res === true && res1 === true) res = true
          if (res === false || res1 === false) res = false
        })

        // console.log(this.debouncedSearch)

        return res
      })
      // filteredArray.sort((a, b) => new Date(this.formatDate1(b.date)) - new Date(this.formatDate1(a.date)))
      return filteredArray
    },
    filteredListSpecialOrdersGlobal () {
      var filteredArray = this.specialOrdersGlobal.filter(order => {
        var keywords = this.searchGlobal.split(' ')
        var res = true
        // if (parseInt(this.specialOrdersSupplier) !== parseInt('0') && parseInt(order.supplier) !== parseInt(this.specialOrdersSupplier)) res = false
        // if (parseInt(this.specialOrdersStatus) !== parseInt('0') && parseInt(order.status) !== parseInt(this.specialOrdersStatus)) res = false
        //  if (parseInt(order.status) === 8) res = false
        // if (parseInt(this.specialOrdersType) !== parseInt('0') && parseInt(order.type) !== parseInt(this.specialOrdersType)) res = false
        if (format(order.date, 'YYYY-MM-DD') < format(this.startDate, 'YYYY-MM-DD') || format(order.date, 'YYYY-MM-DD') > format(this.endDate, 'YYYY-MM-DD')) {
          // console.log('false ')
          res = false
        }

        // console.log('this.specialOrdersStatus ', this.specialOrdersStatus)
        keywords.forEach((element, index) => {
          var str = order.UNP + ' ' + order.client + ' ' + order.manager + ' ' + order.good + ' ' + order.response + ' ' + order.number + '-' + order.version
          var res1 = str.toString().toLowerCase().includes(element.toString().toLowerCase())
          if (res === true && res1 === true) res = true
          if (res === false || res1 === false) res = false
        })

        // console.log(this.debouncedSearch)

        return res
      })
      // filteredArray.sort((a, b) => new Date(this.formatDate1(b.date)) - new Date(this.formatDate1(a.date)))
      return filteredArray
    },
    groupedRecords () {
      const grouped = {}
      const nonGrouped = []

      this.filteredListSpecialOrders.forEach(record => {
        if (record.number !== '') {
          const key = record.number + '_' + record.UNP
          if (!grouped[key]) {
            grouped[key] = {
              date: record.date,
              number: record.number,
              sklad: record.sklad,
              good: record.good,
              UNP: record.UNP,
              ClientUNP: record.ClientUNP,
              manager: record.manager,
              client: record.client,
              quantity: record.quantity,
              data: [{
                guid: record.guid,
                number: record.number,
                version: record.version,
                response: record.response,
                supplier: record.supplier,
                type: record.type,
                price: record.price,
                term: record.term,
                status: record.status,
                ordernumber: record.ordernumber
              }]
            }
          } else {
            grouped[key].data.push({
              guid: record.guid,
              number: record.number,
              version: record.version,
              response: record.response,
              supplier: record.supplier,
              type: record.type,
              price: record.price,
              term: record.term,
              status: record.status,
              ordernumber: record.ordernumber
            })
          }
        } else {
          nonGrouped.unshift({
            date: record.date,
            number: record.number,
            sklad: record.sklad,
            good: record.good,
            UNP: record.UNP,
            ClientUNP: record.ClientUNP,
            manager: record.manager,
            client: record.client,
            quantity: record.quantity,
            data: [{
              guid: record.guid,
              number: record.number,
              version: record.version,
              response: record.response,
              supplier: record.supplier,
              type: record.type,
              price: record.price,
              term: record.term,
              status: record.status,
              ordernumber: record.ordernumber
            }]
          })
        }
      })

      // Сортировка записей с пустым number вверх и по убыванию даты
      nonGrouped.sort((a, b) => new Date(b.date) - new Date(a.date))
      // nonGrouped.sort((a, b) => b.number - a.number)

      // const sortedGrouped = Object.values(grouped).sort((a, b) => new Date(b.date) - new Date(a.date))
      const sortedGrouped = Object.values(grouped).sort((a, b) => b.number - a.number)

      return nonGrouped.concat(sortedGrouped)
    },
    groupedRecordsGlobal () {
      const grouped = {}
      const nonGrouped = []

      this.filteredListSpecialOrdersGlobal.forEach(record => {
        if (record.number !== '') {
          const key = record.number + '_' + record.UNP
          if (!grouped[key]) {
            grouped[key] = {
              date: record.date,
              number: record.number,
              sklad: record.sklad,
              good: record.good,
              UNP: record.UNP,
              manager: record.manager,
              client: record.client,
              type: record.type,
              quantity: record.quantity,
              data: [{
                guid: record.guid,
                number: record.number,
                version: record.version,
                response: record.response,
                supplier: record.supplier,
                price: record.price,
                term: record.term,
                status: record.status,
                ordernumber: record.ordernumber
              }]
            }
          } else {
            grouped[key].data.push({
              guid: record.guid,
              number: record.number,
              version: record.version,
              response: record.response,
              supplier: record.supplier,
              price: record.price,
              term: record.term,
              status: record.status,
              ordernumber: record.ordernumber
            })
          }
        } else {
          nonGrouped.unshift({
            date: record.date,
            number: record.number,
            sklad: record.sklad,
            good: record.good,
            UNP: record.UNP,
            manager: record.manager,
            client: record.client,
            type: record.type,
            quantity: record.quantity,
            data: [{
              guid: record.guid,
              number: record.number,
              version: record.version,
              response: record.response,
              supplier: record.supplier,
              price: record.price,
              term: record.term,
              status: record.status,
              ordernumber: record.ordernumber
            }]
          })
        }
      })

      // Сортировка записей с пустым number вверх и по убыванию даты
      nonGrouped.sort((a, b) => new Date(b.date) - new Date(a.date))

      const sortedGrouped = Object.values(grouped).sort((a, b) => new Date(b.date) - new Date(a.date))

      return nonGrouped.concat(sortedGrouped)
    },
    Prodano () {
      if (this.bonus.length > 0) { return Math.round(this.bonus.filter(client => client.UNP === this.selectedContragent.UNP)[0].Summa) } else return 0
    },
    ProcentVipolneniya () {
      var res = this.bonus.filter(client => client.UNP === this.selectedContragent.UNP)
      if (res.length > 0) {
        // console.log(res[0])
        return Math.round(res[0].ProcSK * 100) / 100
      } else return 0
    },
    SummaSkidki () {
      var res = this.bonus.filter(client => client.UNP === this.selectedContragent.UNP)
      if (res.length > 0) {
        // console.log(res[0])
        return Math.round(res[0].SummaSK)
      } else return 0
    },
    KolBanok () {
      var res = this.bonus.filter(client => client.UNP === this.selectedContragent.UNP)
      if (res.length > 0) {
        // console.log(res[0])
        return Math.round(res[0].KolBanok)
      } else return 0
    }
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  line-height: 1.0;
}

.index-footer-ornament {
  margin-top: -35px;
  background: url(./assets/ornament1.png) top left repeat-x;
  height: 71px !important;
  background-color: #ffffff;
  z-index: 1;
  position: relative;
}

.index-footer-ornament-start {
  margin-top: 0px;
  background: url(./assets/ornament.png) top left repeat-x;
  height: 71px !important;
  background-color: #ffffff;
  z-index: 1;
  position: relative;
}

.input-group-text-sm {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
  padding: 0.01rem 0.01rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.index-ornament {
  margin-top: 1px;
  background: url(./assets/ornament.png) top left repeat-x;
  height: 100px;
  margin-bottom: -38px;
  background-color: #ffffff;
  z-index: 100;

}

.btn.btn-nav {
  padding: 0.1rem 1.0rem;
  font-size: 0.64rem;
}

.nav-item.active>.nav-link:hover {
  border-radius: 1.5rem;
  background-color: #3F729B !important;
}

.btn-call {
  border-radius: 1.5rem;
  color: #dee2e6;
}

.card {
  padding: 5px;
}

main {
  background-color: #e6ecf0;
}

.flexible-content {
  transition: padding-left 0.3s;
  padding-left: 270px;
}

.flexible-navbar {
  transition: padding-left 0.5s;
  padding-left: 270px;
}

.sidebar-fixed {
  left: 0;
  top: 0;
  height: 100vh;
  width: 270px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  z-index: 1050;
  background-color: #fff;
  padding: 1.5rem;
  line-height: 1.0;
  padding-top: 0;
  overflow-y: auto;
}

.sidebar-fixed .logo-wrapper img {
  width: 100%;
  padding: 2.5rem;
}

.sidebar-fixed .list-group-item {
  display: block !important;
  transition: background-color 0.3s;
}

.sidebar-fixed .list-group .active {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  border-radius: 5px;
}

.animated.slow7 {
  animation-duration: 8s;
}

.navbar .nav-item .nav-link {
  display: block;
  border-radius: 1.5rem;
  font-size: larger;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  appearance: textfield;
}

@media (min-width: 480px) and (max-width: 2560px) {
  p {
    font-size: calc(10px + 100vw/200);
  }

  .telnumb {
    font-size: calc(10px + 100vw/400);
  }
}

@media (max-width: 1000px) {
  .sidebar-fixed {
    display: none;
  }

  .flexible-content {
    padding-left: 0;
  }

  .flexible-navbar {
    padding-left: 0px;
  }

  @media only screen and (max-width: 900px) {
    .mobile-hide {
      display: none !important;
    }

    body {

      line-height: 1;

    }

    .modal-content {
      width: 60% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue